import classnames from 'classnames';
import { withTheme } from 'emotion-theming';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactAutocomplete from 'react-autocomplete';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import 'moment';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	caches: caches,
	css: css,
	cx: cx,
	flush: flush,
	getRegisteredStyles: getRegisteredStyles,
	hydrate: hydrate,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	merge: merge,
	sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

var internalPaddingRegular = '\n    overflow: auto;\n    padding-left: ' + spacing.DOUBLE + ';\n    padding-top: ' + spacing.DOUBLE + ';\n';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(217,33%,38%)',
  blueLighter: 'hsl(210, 97%, 87%)',
  blueLightest: 'hsl(210, 100%, 95%)',
  green: 'hsl(135, 41%, 48%)',
  greenUpdated: 'hsl(67, 100%, 35%)',
  greenLighter: 'hsl(90, 53%, 70%)',
  greenLightest: 'hsl(90, 61%, 88%)',
  greenLightestUpdated: 'hsl(66, 75%, 75%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyUpdated: 'hsl(0, 0%, 55%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  greyLightestUpdated: 'hsl(0, 0%, 91%)',
  orange: 'hsl(29, 77%, 56%)',
  orangeUpdated: 'hsl(28, 100%, 54%)',
  orangeLighter: 'hsl(30, 45%, 89%)',
  orangeLightestUpdated: 'hsl(31, 100%, 63%)',
  red: 'hsl(360, 93%, 41%)',
  redUpdated: 'hsl(360, 91%, 46%)',
  redLighter: 'hsl(360, 97%, 77%)',
  redLightest: 'hsl(360, 60%, 96%)',
  redLightestUpdated: 'hsl(10, 94%, 80%)',
  yellowLighter: 'hsl(55, 92%, 69%)',
  yellowLightest: 'hsl(55, 100%, 88%)',
  white: 'hsl(0, 0%, 100%)',
  whiteOff: 'hsl(0, 0%, 95%)',
  pebble: 'hsl(210, 46%, 91%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLighter = generalPalette.blueLighter,
    blueLightest = generalPalette.blueLightest,
    green = generalPalette.green,
    greenUpdated = generalPalette.greenUpdated,
    greenLighter = generalPalette.greenLighter,
    greenFaint = generalPalette.greenFaint,
    greenLightest = generalPalette.greenLightest,
    greenLightestUpdated = generalPalette.greenLightestUpdated,
    greyUpdated = generalPalette.greyUpdated,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    greyLightestUpdated = generalPalette.greyLightestUpdated,
    orange = generalPalette.orange,
    orangeLighter = generalPalette.orangeLighter,
    red = generalPalette.red,
    redUpdated = generalPalette.redUpdated,
    redLighter = generalPalette.redLighter,
    redLightest = generalPalette.redLightest,
    redLightestUpdated = generalPalette.redLightestUpdated,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    yellowLighter = generalPalette.yellowLighter,
    yellowLightest = generalPalette.yellowLightest,
    white = generalPalette.white,
    whiteOff = generalPalette.whiteOff,
    pebble = generalPalette.pebble;


var colours = {
  generalPalette: {
    black: black,
    blue: blue,
    blueLighter: blueLighter,
    blueLightest: blueLightest,
    green: green,
    greenUpdated: greenUpdated,
    greenLighter: greenLighter,
    greenLightest: greenLightest,
    greenLightestUpdated: greenLightestUpdated,
    greenFaint: greenFaint,
    greyDarkest: greyDarkest,
    greyDarker: greyDarker,
    grey: grey,
    greyUpdated: greyUpdated,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    greyLightestUpdated: greyLightestUpdated,
    orange: orange,
    orangeLighter: orangeLighter,
    pebble: pebble,
    red: red,
    redUpdated: redUpdated,
    redLighter: yellowLightest,
    redLightest: redLightest,
    redLightestUpdated: redLightestUpdated,
    yellowLighter: yellowLighter,
    yellowLightest: yellowLightest,
    white: white,
    whiteOff: whiteOff
  },
  component: {
    background: white,
    backgroundDisabled: greyLightest,
    border: greyLightest,
    borderDisabled: greyDarkest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    modalBackdrop: black,
    shell: whiteOff,
    tableCell: 'hsl(0, 0%, 97%)',
    tableHeader: 'hsl(0, 0%, 94%)',
    navigationButtonDisabled: 'hsl(215, 8%, 58%)',
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, ' + blue + ', ' + (blue + ' 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)'),
        content: blue,
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    error: red,
    errorUpdated: redUpdated,
    errorLighter: redLighter,
    errorLightest: redLightest,
    errorLightestUpdated: redLightestUpdated,
    guidance: blue,
    guidanceLighter: blueLighter,
    guidanceLightest: blueLightest,
    important: red,
    importantLighter: redLighter,
    importantLightest: redLightest,
    indicative: orange,
    information: blue,
    informationUpdated: greyUpdated,
    informationLightest: blueLightest,
    informationLightestUpdated: greyLightestUpdated,
    negative: red,
    positive: green,
    rememberLighter: yellowLighter,
    rememberLightest: yellowLightest,
    success: green,
    successUpdated: greenUpdated,
    successLighter: greenLighter,
    successLightest: greenLightest,
    successLightestUpdated: greenLightestUpdated,
    successDisabled: greenFaint,
    tip: green,
    tipLighter: greenLighter,
    tipLightest: greenLightest,
    warning: orange
  },
  state: {
    active: green,
    archived: greyLightest,
    inactive: red,
    notStarted: greyDarker,
    paused: blue,
    pending: orange
  }
};

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
	lewis: {
		xs1: { fontSize: 37, lineHeight: 1.189 },
		sm1: { fontSize: 37, lineHeight: 1.189 },
		md1: { fontSize: 45, lineHeight: 1.067 },
		lg1: { fontSize: 52, lineHeight: 1.154 },
		xl1: { fontSize: 52, lineHeight: 1.154 }
	},
	skye: {
		xs1: { fontSize: 32, lineHeight: 1.125 },
		sm1: { fontSize: 32, lineHeight: 1.125 },
		md1: { fontSize: 40, lineHeight: 1.1 },
		lg1: { fontSize: 45, lineHeight: 1.156 },
		xl1: { fontSize: 45, lineHeight: 1.156 }
	},
	shetland: {
		xs1: { fontSize: 29, lineHeight: 1.241 },
		sm1: { fontSize: 29, lineHeight: 1.241 },
		md1: { fontSize: 34, lineHeight: 1.176 },
		lg1: { fontSize: 39, lineHeight: 1.128 },
		xl1: { fontSize: 39, lineHeight: 1.128 }
	},
	mull: {
		xs1: { fontSize: 26, lineHeight: 1.231 },
		sm1: { fontSize: 26, lineHeight: 1.231 },
		md1: { fontSize: 29, lineHeight: 1.241 },
		lg1: { fontSize: 33, lineHeight: 1.212 },
		xl1: { fontSize: 33, lineHeight: 1.212 }
	},
	islay: {
		xs1: { fontSize: 23, lineHeight: 1.217 },
		sm1: { fontSize: 23, lineHeight: 1.217 },
		md1: { fontSize: 25, lineHeight: 1.28 },
		lg1: { fontSize: 28, lineHeight: 1.286 },
		xl1: { fontSize: 28, lineHeight: 1.286 }
	},
	orkney: {
		xs1: { fontSize: 20, lineHeight: 1.4 },
		sm1: { fontSize: 20, lineHeight: 1.4 },
		md1: { fontSize: 22, lineHeight: 1.273 },
		lg1: { fontSize: 25, lineHeight: 1.28 },
		xl1: { fontSize: 25, lineHeight: 1.28 }
	},
	arran: {
		xs1: { fontSize: 18, lineHeight: 1.333 },
		sm1: { fontSize: 18, lineHeight: 1.333 },
		md1: { fontSize: 19, lineHeight: 1.474 },
		lg1: { fontSize: 21, lineHeight: 1.333 },
		xl1: { fontSize: 21, lineHeight: 1.333 }
	},
	jura: {
		xs1: { fontSize: 16, lineHeight: 1.5 },
		sm1: { fontSize: 16, lineHeight: 1.5 },
		md1: { fontSize: 16, lineHeight: 1.5 },
		lg1: { fontSize: 18, lineHeight: 1.556 },
		xl1: { fontSize: 18, lineHeight: 1.556 }
	},
	uist: {
		xs1: { fontSize: 14, lineHeight: 1.429 },
		sm1: { fontSize: 14, lineHeight: 1.429 },
		md1: { fontSize: 14, lineHeight: 1.429 },
		lg1: { fontSize: 16, lineHeight: 1.5 },
		xl1: { fontSize: 16, lineHeight: 1.5 }
	},
	bute: {
		xs1: { fontSize: 12, lineHeight: 1.333 },
		sm1: { fontSize: 12, lineHeight: 1.333 },
		md1: { fontSize: 13, lineHeight: 1.538 },
		lg1: { fontSize: 13, lineHeight: 1.538 },
		xl1: { fontSize: 13, lineHeight: 1.538 }
	},
	cumbrae: {
		xs1: { fontSize: 11, lineHeight: 1.455 },
		sm1: { fontSize: 11, lineHeight: 1.455 },
		md1: { fontSize: 12, lineHeight: 1.333 },
		lg1: { fontSize: 12, lineHeight: 1.333 },
		xl1: { fontSize: 12, lineHeight: 1.333 }
	}
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
	var styles = '';
	if (parseInt(mqBreakpoint) === 0) {
		styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
	} else {
		styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      }\n    ';
	}
	return styles;
};

var fontSizes = {};

for (var fontSize in fontConfig) {
	if (fontConfig.hasOwnProperty(fontSize)) {
		var style = '';
		for (var breakpoint in fontConfig[fontSize]) {
			if (fontConfig[fontSize].hasOwnProperty(breakpoint)) {
				var _fontConfig$fontSize$ = fontConfig[fontSize][breakpoint],
				    size = _fontConfig$fontSize$.fontSize,
				    lineHeight = _fontConfig$fontSize$.lineHeight;

				style += generateSASS(breakpoints[breakpoint], size, lineHeight);
			}
		}
		fontSizes[fontSize] = style;
	}
}

var useFontSize = {

	of: {
		lewis: function lewis() {
			return fontSizes['lewis'];
		},
		skye: function skye() {
			return fontSizes['skye'];
		},
		shetland: function shetland() {
			return fontSizes['shetland'];
		},
		mull: function mull() {
			return fontSizes['mull'];
		},
		islay: function islay() {
			return fontSizes['islay'];
		},
		orkney: function orkney() {
			return fontSizes['orkney'];
		},
		arran: function arran() {
			return fontSizes['arran'];
		},
		jura: function jura() {
			return fontSizes['jura'];
		},
		uist: function uist() {
			return fontSizes['uist'];
		},
		bute: function bute() {
			return fontSizes['bute'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['cumbrae'];
		}
	},

	biggerThan: {
		lewis: function lewis() {
			throw new Error("lewis is the biggest font");
		},
		skye: function skye() {
			return fontSizes['lewis'];
		},
		shetland: function shetland() {
			return fontSizes['skye'];
		},
		mull: function mull() {
			return fontSizes['shetland'];
		},
		islay: function islay() {
			return fontSizes['mull'];
		},
		orkney: function orkney() {
			return fontSizes['islay'];
		},
		arran: function arran() {
			return fontSizes['orkney'];
		},
		jura: function jura() {
			return fontSizes['arran'];
		},
		uist: function uist() {
			return fontSizes['jura'];
		},
		bute: function bute() {
			return fontSizes['uist'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['bute'];
		}
	},

	smallerThan: {
		lewis: function lewis() {
			return fontSizes['skye'];
		},
		skye: function skye() {
			return fontSizes['shetland'];
		},
		shetland: function shetland() {
			return fontSizes['mull'];
		},
		mull: function mull() {
			return fontSizes['islay'];
		},
		islay: function islay() {
			return fontSizes['orkney'];
		},
		orkney: function orkney() {
			return fontSizes['arran'];
		},
		arran: function arran() {
			return fontSizes['jura'];
		},
		jura: function jura() {
			return fontSizes['uist'];
		},
		uist: function uist() {
			return fontSizes['bute'];
		},
		bute: function bute() {
			return fontSizes['cumbrae'];
		},
		cumbrae: function cumbrae() {
			throw new Error("cumbrae is the smallest font");
		}
	}
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20.42 20.42a6.252 6.252 0 0 0 0 8.843l18.733 18.734-18.735 18.746a6.251 6.251 0 0 0 8.842 8.837l18.734-18.735L66.738 75.58a6.252 6.252 0 1 0 8.842-8.843L56.835 47.992l18.739-18.74a6.248 6.248 0 0 0 .003-8.834 6.24 6.24 0 0 0-8.827-.003L48.01 39.155 29.263 20.42a6.253 6.253 0 0 0-8.843.002z" }));
});

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M72.133 17.58l6.464 6.465L54.4 48.241l24.197 24.197-6.464 6.464-24.196-24.196L23.74 78.902l-6.464-6.464 24.196-24.197-24.196-24.196 6.464-6.464 24.197 24.196z" }));
});

var getCrossSolidSmall = getThemeIcon(VMIcon, GenericIcon);

var LIFE_CYCLE_STATUSES = {
	ACTIVE: 'active',
	BESPOKE: 'bespoke',
	DEPRECATED: 'deprecated',
	DRAFT: 'draft',
	OUTDATED: 'outdated'
};

var checkIsVariantDeprecatedFromPackageJson = function checkIsVariantDeprecatedFromPackageJson(packageJson, variant) {
	var deprecations = packageJson.deprecations;


	if (!deprecations) {
		return false;
	}

	var isDeprecated = false;
	deprecations.forEach(function (deprecationObj) {
		return deprecationObj.variants && deprecationObj.variants.forEach(function (deprecatedVariant) {
			if (deprecatedVariant === variant) {
				isDeprecated = true;
			}
		});
	});
	return isDeprecated;
};

var getComponentProminentStatusFromPackage = function getComponentProminentStatusFromPackage(packageJson, variant) {
	var isComponentDeprecated = packageJson['component-life-cycle'] === LIFE_CYCLE_STATUSES.DEPRECATED;
	var isVariantDeprecated = variant && checkIsVariantDeprecatedFromPackageJson(packageJson, variant);

	if (isComponentDeprecated || isVariantDeprecated) {
		return LIFE_CYCLE_STATUSES.DEPRECATED;
	}

	if (packageJson['is-bespoke']) {
		return LIFE_CYCLE_STATUSES.BESPOKE;
	}

	return packageJson['component-life-cycle'];
};

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var WEE_WORDS = ['an', 'is', 'of', 'to'];

var capitaliseFirstLetterExceptWeeOnes = function capitaliseFirstLetterExceptWeeOnes(value) {
	if (WEE_WORDS.includes(value)) {
		return value;
	}

	return capitaliseFirstLetter(value);
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var slugifyString = function slugifyString(name) {
	return ('' + name.toLowerCase()).replace(' ', '-');
};

var StringUtils = {
	addFullStop: addFullStop,
	capitaliseFirstLetter: capitaliseFirstLetter,
	capitaliseFirstLetterExceptWeeOnes: capitaliseFirstLetterExceptWeeOnes,
	lowercaseFirstLetter: lowercaseFirstLetter,
	slugifyString: slugifyString
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledInternalStandardBody = styled('div')(_templateObject$1, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalStandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-standardbody'
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.generalPalette.black, function (props) {
	return props.level % 2 > 0 ? colours.generalPalette.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme,
	    dataTestId = _ref['data-test-id'];

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	var contentId = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') + '-content-id' : 'content-reveal-panel-id';
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button',
				'data-test-id': dataTestId + '-button',
				'aria-expanded': isOpen,
				'aria-controls': contentId
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{
				isOpen: isOpen,
				panelColour: panelColour,
				id: contentId,
				'data-test-id': dataTestId + '-content'
			},
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** Optional icon  */
	icon: PropTypes.node,
	/** Data attribute targeting inner html button for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false,
	'data-test-id': 'content-reveal-panel'
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: ', ';\n'], ['\n\t', ';\n\tdisplay: ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
	return props.isInlineBlock ? 'inline-block' : 'inline';
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, spacing.HALF, colours.generalPalette.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.generalPalette.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.generalPalette.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatusFromPackage(packageJson, variant);
			var formattedStatus = StringUtils.capitaliseFirstLetter(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline-block' || layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ isInlineBlock: layout === 'inline-block', removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'container', 'inline', 'inline-block', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var main = "Field.js";
var deprecations = [{
	replacements: {
		name: "GenericFieldWrapper",
		path: "Layout/Field-wrappers"
	}
}];
var packageJson = {
	main: main,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations
};

var Field = function Field(_ref) {
	var children = _ref.children,
	    className = _ref.className;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson, hasCustomMargins: true },
		React.createElement(
			'div',
			{ className: classnames('c-m-form-field', className) },
			children
		)
	);
};

Field.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	className: PropTypes.string
};

var main$1 = "FieldBody.js";
var deprecations$1 = [{
	replacements: {
		name: "GenericFieldWrapper",
		path: "Layout/Field-wrappers"
	}
}];
var packageJson$1 = {
	main: main$1,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$1
};

var classNames = function classNames(hasError) {
	return classnames({
		'o-block-field': true,
		'c-m-form-field__body': true,
		'o-block-field--error': hasError
	});
};

var FieldBody = function FieldBody(_ref) {
	var children = _ref.children,
	    hasError = _ref.hasError,
	    rest = objectWithoutProperties(_ref, ['children', 'hasError']);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$1, hasCustomMargins: true },
		React.createElement(
			'div',
			_extends({ className: classNames(hasError) }, rest),
			children
		)
	);
};

FieldBody.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
	hasError: PropTypes.bool
};

var FieldDescription = function FieldDescription(_ref) {
	var children = _ref.children;
	return React.createElement(
		'div',
		{ className: 'c-a-field-description' },
		React.createElement(
			'p',
			null,
			children
		)
	);
};

FieldDescription.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
};

var main$2 = "Label.js";
var deprecations$2 = [{
	replacements: {
		name: "GenericFieldWrapper",
		path: "Layout/Field-wrappers"
	}
}];
var packageJson$2 = {
	main: main$2,
	"component-id": "null",
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$2
};

/* eslint-disable jsx-a11y/label-has-for */
var Label = function Label(_ref) {
	var className = _ref.className,
	    htmlFor = _ref.htmlFor,
	    form = _ref.form,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$2, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			'label',
			{ className: classnames('c-a-label', className), htmlFor: htmlFor, form: form },
			children
		)
	);
};

Label.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
	form: PropTypes.string,
	htmlFor: PropTypes.string,
	className: PropTypes.string
};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-.932-9.452L7 4h2l-.068 1.548L8.65 9H7.35l-.283-3.452zM7 11.005c0-.288.096-.528.287-.719A.968.968 0 0 1 8 10a.975.975 0 0 1 1 1.005.962.962 0 0 1-.287.709A.968.968 0 0 1 8 12a.968.968 0 0 1-.713-.286.962.962 0 0 1-.287-.709z", fillRule: "evenodd" }));
});

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0zm0 61.714c-1.952 0-3.583.655-4.892 1.965-1.31 1.31-1.965 2.953-1.965 4.93 0 1.927.655 3.545 1.965 4.855 1.31 1.31 2.94 1.965 4.892 1.965s3.583-.655 4.892-1.965c1.31-1.31 1.965-2.928 1.965-4.856 0-1.976-.655-3.62-1.965-4.93-1.31-1.309-2.94-1.964-4.892-1.964zm6.857-41.143H41.143l.463 10.613 1.946 23.673h8.896l1.946-23.673z", fillRule: "evenodd" }));
});

var getExclamationCircleLarge = getThemeIcon(VMIcon$2, GenericIcon$2);

var main$3 = "StandardBody.js";
var packageJson$3 = {
	main: main$3,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

/**
 * @example ./Design.md
 */
var StandardBody = function StandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$3, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			InternalStandardBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

StandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

StandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'standardbody'
};

var main$4 = "ValidationMessageTile.js";
var packageJson$4 = {
	main: main$4,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$5 = taggedTemplateLiteral(['\n\talign-items: flex-start;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\t', ';\n'], ['\n\talign-items: flex-start;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\t', ';\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n'], ['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n']);

var StyledWrapper$1 = styled('div')(_templateObject$5, colours.utility.errorLightest, colours.utility.error, function (props) {
	return props.theme.borderRadiusLarger;
}, internalPaddingRegular);

var StyledIconWrapper = styled('div')(_templateObject2$4, spacing.DOUBLE, colours.utility.error);

// eslint-disable-next-line react/prop-types
var ValidationMessageTile = function ValidationMessageTile(_ref) {
	var dataTestId = _ref['data-test-id'],
	    messageText = _ref.messageText,
	    theme = _ref.theme;

	var ExclamationCircleLarge = getExclamationCircleLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(
			StyledWrapper$1,
			{ 'data-test-id': dataTestId, role: 'alert', 'aria-atomic': 'true' },
			React.createElement(
				StyledIconWrapper,
				null,
				React.createElement(ExclamationCircleLarge, null)
			),
			React.createElement(
				StandardBody,
				null,
				messageText
			)
		)
	);
};

ValidationMessageTile.propTypes = {
	/** Data attribute targeting select for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Content of the message. */
	messageText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

ValidationMessageTile.defaultProps = {
	'data-test-id': 'validation-message-tile'
};

var ValidationMessageTileWithTheme = withTheme(ValidationMessageTile);

var componentPaths = [
	{
		name: "ActionAnchor",
		path: "actions/anchors/ActionAnchor",
		styleguidePath: "Actions/Anchors/ActionAnchor",
		importPath: "web-ui-components/lib/actions/anchors"
	},
	{
		name: "ActionButton",
		path: "actions/buttons/ActionButton",
		styleguidePath: "Actions/Buttons/ActionButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "SwitchButton",
		path: "actions/buttons/SwitchButton",
		styleguidePath: "Actions/Buttons/SwitchButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "EmailLink",
		path: "actions/links/EmailLink",
		styleguidePath: "Actions/Links/EmailLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "PhoneLink",
		path: "actions/links/PhoneLink",
		styleguidePath: "Actions/Links/PhoneLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "WebsiteLink",
		path: "actions/links/WebsiteLink",
		styleguidePath: "Actions/Links/WebsiteLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "InputRadio",
		path: "actions/radios/InputRadio",
		styleguidePath: "Actions/Radios/InputRadio",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "InputRadioGroup",
		path: "actions/radios/InputRadioGroup",
		styleguidePath: "Actions/Radios/InputRadioGroup",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "TallRadioCard",
		path: "actions/radios/TallRadioCard",
		styleguidePath: "Actions/Radios/TallRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "WideRadioCard",
		path: "actions/radios/WideRadioCard",
		styleguidePath: "Actions/Radios/WideRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "NewWindowAction",
		path: "advisor/actions/NewWindowAction",
		styleguidePath: "Advisor/Actions/NewWindowAction",
		importPath: "web-ui-components/lib/advisor/actions"
	},
	{
		name: "CustomerAlert",
		path: "advisor/alerts/CustomerAlert",
		styleguidePath: "Advisor/Alerts/CustomerAlert",
		importPath: "web-ui-components/lib/advisor/alerts"
	},
	{
		name: "ClickableContentFrame",
		path: "advisor/layout/ClickableContentFrame",
		styleguidePath: "Advisor/Layout/ClickableContentFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "DashboardGrid",
		path: "advisor/layout/DashboardGrid",
		styleguidePath: "Advisor/Layout/DashboardGrid",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WideModal",
		path: "advisor/layout/WideModal",
		styleguidePath: "Advisor/Layout/WideModal",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WindowFrame",
		path: "advisor/layout/WindowFrame",
		styleguidePath: "Advisor/Layout/WindowFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "ProductRadioCard",
		path: "advisor/radios/ProductRadioCard",
		styleguidePath: "Advisor/Radios/ProductRadioCard",
		importPath: "web-ui-components/lib/advisor/radios"
	},
	{
		name: "AccountSelect",
		path: "advisor/selects/AccountSelect",
		styleguidePath: "Advisor/Selects/AccountSelect",
		importPath: "web-ui-components/lib/advisor/selects"
	},
	{
		name: "SessionTimeoutTakeover",
		path: "advisor/takeovers/SessionTimeoutTakeover",
		styleguidePath: "Advisor/Takeovers/SessionTimeoutTakeover",
		importPath: "web-ui-components/lib/advisor/takeovers"
	},
	{
		name: "Anchor",
		path: "atoms/buttons/Anchor",
		styleguidePath: "Atoms/Buttons/Anchor",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Button",
		path: "atoms/buttons/Button",
		styleguidePath: "Atoms/Buttons/Button",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "ButtonTitle",
		path: "atoms/buttons/ButtonTitle",
		styleguidePath: "Atoms/Buttons/ButtonTitle",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Calendar",
		path: "atoms/forms/Calendar",
		styleguidePath: "Atoms/Forms/Calendar",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Checkbox",
		path: "atoms/forms/Checkbox",
		styleguidePath: "Atoms/Forms/Checkbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "CheckboxToggle",
		path: "atoms/forms/CheckboxToggle",
		styleguidePath: "Atoms/Forms/CheckboxToggle",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Datepicker",
		path: "atoms/forms/Datepicker",
		styleguidePath: "Atoms/Forms/Datepicker",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "FieldDescription",
		path: "atoms/forms/FieldDescription",
		styleguidePath: "Atoms/Forms/FieldDescription",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Input",
		path: "atoms/forms/Input/Input",
		styleguidePath: "Atoms/Forms/Input/Input",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Prefix",
		path: "atoms/forms/Input/Prefix",
		styleguidePath: "Atoms/Forms/Input/Prefix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Suffix",
		path: "atoms/forms/Input/Suffix",
		styleguidePath: "Atoms/Forms/Input/Suffix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "TextPrompt",
		path: "atoms/forms/Input/TextPrompt",
		styleguidePath: "Atoms/Forms/Input/TextPrompt",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "InputClickable",
		path: "atoms/forms/InputClickable",
		styleguidePath: "Atoms/Forms/InputClickable",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "InputRange",
		path: "atoms/forms/InputRange",
		styleguidePath: "Atoms/Forms/InputRange",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "LabelTitle",
		path: "atoms/forms/Label/LabelTitle",
		styleguidePath: "Atoms/Forms/Label/LabelTitle",
		importPath: "web-ui-components/lib/atoms/forms/label"
	},
	{
		name: "Label",
		path: "atoms/forms/Label",
		styleguidePath: "Atoms/Forms/Label",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaCheckbox",
		path: "atoms/forms/MediaCheckbox",
		styleguidePath: "Atoms/Forms/MediaCheckbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaRadio",
		path: "atoms/forms/MediaRadio",
		styleguidePath: "Atoms/Forms/MediaRadio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MultiSelect",
		path: "atoms/forms/MultiSelect",
		styleguidePath: "Atoms/Forms/MultiSelect",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Radio",
		path: "atoms/forms/Radio",
		styleguidePath: "Atoms/Forms/Radio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "RadioCard",
		path: "atoms/forms/RadioCard",
		styleguidePath: "Atoms/Forms/RadioCard",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Select",
		path: "atoms/forms/Select",
		styleguidePath: "Atoms/Forms/Select",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Textarea",
		path: "atoms/forms/Textarea",
		styleguidePath: "Atoms/Forms/Textarea",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TextAreaCharacterCount",
		path: "atoms/forms/TextAreaCharacterCount",
		styleguidePath: "Atoms/Forms/TextAreaCharacterCount",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TimeEstimationIcon",
		path: "atoms/forms/TimeEstimationIcon",
		styleguidePath: "Atoms/Forms/TimeEstimationIcon",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "AnimatedIcon",
		path: "atoms/iconography/AnimatedIcon",
		styleguidePath: "Atoms/Iconography/AnimatedIcon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "DistinctiveGeneratedSymbol",
		path: "atoms/iconography/DistinctiveGeneratedSymbol",
		styleguidePath: "Atoms/Iconography/DistinctiveGeneratedSymbol",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Icon",
		path: "atoms/iconography/Icon",
		styleguidePath: "Atoms/Iconography/Icon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Divider",
		path: "atoms/layout/Divider",
		styleguidePath: "Atoms/Layout/Divider",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "UploadPreviewContainer",
		path: "atoms/layout/UploadPreviewContainer",
		styleguidePath: "Atoms/Layout/UploadPreviewContainer",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "AndroidStoreLogo",
		path: "atoms/logo/AndroidStoreLogo",
		styleguidePath: "Atoms/Logo/AndroidStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "AppleStoreLogo",
		path: "atoms/logo/AppleStoreLogo",
		styleguidePath: "Atoms/Logo/AppleStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BankHeader",
		path: "atoms/logo/BankHeader",
		styleguidePath: "Atoms/Logo/BankHeader",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogo",
		path: "atoms/logo/BLogo",
		styleguidePath: "Atoms/Logo/BLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogoCircular",
		path: "atoms/logo/BLogoCircular",
		styleguidePath: "Atoms/Logo/BLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogo",
		path: "atoms/logo/CBLogo",
		styleguidePath: "Atoms/Logo/CBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogoCircular",
		path: "atoms/logo/CBLogoCircular",
		styleguidePath: "Atoms/Logo/CBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Header",
		path: "atoms/logo/Header",
		styleguidePath: "Atoms/Logo/Header",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "SwitchGuaranteeLogo",
		path: "atoms/logo/SwitchGuaranteeLogo",
		styleguidePath: "Atoms/Logo/SwitchGuaranteeLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "VMSecondaryRedLogo",
		path: "atoms/logo/VMSecondaryRedLogo",
		styleguidePath: "Atoms/Logo/VMSecondaryRedLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogo",
		path: "atoms/logo/YBLogo",
		styleguidePath: "Atoms/Logo/YBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogoCircular",
		path: "atoms/logo/YBLogoCircular",
		styleguidePath: "Atoms/Logo/YBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Popover",
		path: "atoms/popovers/Popover",
		styleguidePath: "Atoms/Popovers/Popover",
		importPath: "web-ui-components/lib/atoms/popovers"
	},
	{
		name: "IdentityProcessingSignal",
		path: "atoms/signals/IdentityProcessingSignal",
		styleguidePath: "Atoms/Signals/IdentityProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "UploadProcessingSignal",
		path: "atoms/signals/UploadProcessingSignal",
		styleguidePath: "Atoms/Signals/UploadProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "BadgeLabel",
		path: "atoms/text/BadgeLabel",
		styleguidePath: "Atoms/Text/BadgeLabel",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "BulletedList",
		path: "atoms/text/BulletedList",
		styleguidePath: "Atoms/Text/BulletedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Callout",
		path: "atoms/text/Callout",
		styleguidePath: "Atoms/Text/Callout",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "List",
		path: "atoms/text/List",
		styleguidePath: "Atoms/Text/List",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "NumberedList",
		path: "atoms/text/NumberedList",
		styleguidePath: "Atoms/Text/NumberedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "StatusBadge",
		path: "atoms/text/StatusBadge",
		styleguidePath: "Atoms/Text/StatusBadge",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextBody",
		path: "atoms/text/TextBody",
		styleguidePath: "Atoms/Text/TextBody",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextStyled",
		path: "atoms/text/TextStyled",
		styleguidePath: "Atoms/Text/TextStyled",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TheSmallPrint",
		path: "atoms/text/TheSmallPrint",
		styleguidePath: "Atoms/Text/TheSmallPrint",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Title",
		path: "atoms/text/Title",
		styleguidePath: "Atoms/Text/Title",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TransitionBlock",
		path: "atoms/transitions/TransitionBlock",
		styleguidePath: "Atoms/Transitions/TransitionBlock",
		importPath: "web-ui-components/lib/atoms/transitions"
	},
	{
		name: "EmailInput",
		path: "communication/email/text-inputs/EmailInput",
		styleguidePath: "Communication/Email/Text-inputs/EmailInput",
		importPath: "web-ui-components/lib/communication/email/text-inputs"
	},
	{
		name: "Mail",
		path: "communication/messaging/Mail",
		styleguidePath: "Communication/Messaging/Mail",
		importPath: "web-ui-components/lib/communication/messaging"
	},
	{
		name: "Webchat",
		path: "communication/support/Webchat",
		styleguidePath: "Communication/Support/Webchat",
		importPath: "web-ui-components/lib/communication/support"
	},
	{
		name: "CheckboxContainer",
		path: "data/capture/checkboxes/CheckboxContainer",
		styleguidePath: "Data/Capture/Checkboxes/CheckboxContainer",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "GenericCheckbox",
		path: "data/capture/checkboxes/GenericCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/GenericCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "StandaloneCheckbox",
		path: "data/capture/checkboxes/StandaloneCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/StandaloneCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "AccountNumberInput",
		path: "data/capture/inputs/AccountNumberInput",
		styleguidePath: "Data/Capture/Inputs/AccountNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DateOfBirthInput",
		path: "data/capture/inputs/DateOfBirthInput",
		styleguidePath: "Data/Capture/Inputs/DateOfBirthInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "FileUploadInput",
		path: "data/capture/inputs/FileUploadInput",
		styleguidePath: "Data/Capture/Inputs/FileUploadInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericAlphaNumericInput",
		path: "data/capture/inputs/GenericAlphaNumericInput",
		styleguidePath: "Data/Capture/Inputs/GenericAlphaNumericInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericIntegerInput",
		path: "data/capture/inputs/GenericIntegerInput",
		styleguidePath: "Data/Capture/Inputs/GenericIntegerInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericTextInput",
		path: "data/capture/inputs/GenericTextInput",
		styleguidePath: "Data/Capture/Inputs/GenericTextInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "LandlineNumberInput",
		path: "data/capture/inputs/LandlineNumberInput",
		styleguidePath: "Data/Capture/Inputs/LandlineNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MoneyInput",
		path: "data/capture/inputs/MoneyInput",
		styleguidePath: "Data/Capture/Inputs/MoneyInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MonthAndYearDateInput",
		path: "data/capture/inputs/MonthAndYearDateInput",
		styleguidePath: "Data/Capture/Inputs/MonthAndYearDateInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "PasscodeNumberInput",
		path: "data/capture/inputs/PasscodeNumberInput",
		styleguidePath: "Data/Capture/Inputs/PasscodeNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SliderInput",
		path: "data/capture/inputs/SliderInput",
		styleguidePath: "Data/Capture/Inputs/SliderInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SortcodeInput",
		path: "data/capture/inputs/SortcodeInput",
		styleguidePath: "Data/Capture/Inputs/SortcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyMobileNumberInput",
		path: "data/capture/inputs/UKOnlyMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyPostcodeInput",
		path: "data/capture/inputs/UKOnlyPostcodeInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyPostcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "WorldwideMobileNumberInput",
		path: "data/capture/inputs/WorldwideMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/WorldwideMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "YearsAndMonthsCountInput",
		path: "data/capture/inputs/YearsAndMonthsCountInput",
		styleguidePath: "Data/Capture/Inputs/YearsAndMonthsCountInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DayOfMonthPicker",
		path: "data/capture/pickers/DayOfMonthPicker",
		styleguidePath: "Data/Capture/Pickers/DayOfMonthPicker",
		importPath: "web-ui-components/lib/data/capture/pickers"
	},
	{
		name: "FileProgressTakeover",
		path: "data/capture/progress/FileProgressTakeover",
		styleguidePath: "Data/Capture/Progress/FileProgressTakeover",
		importPath: "web-ui-components/lib/data/capture/progress"
	},
	{
		name: "GenericRadio",
		path: "data/capture/radios/GenericRadio",
		styleguidePath: "Data/Capture/Radios/GenericRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "IconifiedRadio",
		path: "data/capture/radios/IconifiedRadio",
		styleguidePath: "Data/Capture/Radios/IconifiedRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "RadioContainer",
		path: "data/capture/radios/RadioContainer",
		styleguidePath: "Data/Capture/Radios/RadioContainer",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "AccountCardSelect",
		path: "data/capture/selects/AccountCardSelect",
		styleguidePath: "Data/Capture/Selects/AccountCardSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericSelect",
		path: "data/capture/selects/GenericSelect",
		styleguidePath: "Data/Capture/Selects/GenericSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericTextArea",
		path: "data/capture/text-areas/GenericTextArea",
		styleguidePath: "Data/Capture/Text-areas/GenericTextArea",
		importPath: "web-ui-components/lib/data/capture/text-areas"
	},
	{
		name: "InternationalMoneyValue",
		path: "data/display/values/InternationalMoneyValue",
		styleguidePath: "Data/Display/Values/InternationalMoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "MoneyValue",
		path: "data/display/values/MoneyValue",
		styleguidePath: "Data/Display/Values/MoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "GenericPaginator",
		path: "data/filter-and-search/paginators/GenericPaginator",
		styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator",
		importPath: "web-ui-components/lib/data/filter-and-search/paginators"
	},
	{
		name: "SearchSelectInput",
		path: "data/filter-and-search/text-inputs/SearchSelectInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchSelectInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "SearchTextInput",
		path: "data/filter-and-search/text-inputs/SearchTextInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchTextInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "CompactDescriptionList",
		path: "data/lists/description-lists/CompactDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/CompactDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "GenericDescriptionList",
		path: "data/lists/description-lists/GenericDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/GenericDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "NoResultsTile",
		path: "data/results/tiles/NoResultsTile",
		styleguidePath: "Data/Results/Tiles/NoResultsTile",
		importPath: "web-ui-components/lib/data/results/tiles"
	},
	{
		name: "DocumentLink",
		path: "documents/navigation/links/DocumentLink",
		styleguidePath: "Documents/Navigation/Links/DocumentLink",
		importPath: "web-ui-components/lib/documents/navigation/links"
	},
	{
		name: "DocumentLinkPlate",
		path: "documents/navigation/plates/DocumentLinkPlate",
		styleguidePath: "Documents/Navigation/Plates/DocumentLinkPlate",
		importPath: "web-ui-components/lib/documents/navigation/plates"
	},
	{
		name: "PrintButton",
		path: "documents/printing/buttons/PrintButton",
		styleguidePath: "Documents/Printing/Buttons/PrintButton",
		importPath: "web-ui-components/lib/documents/printing/buttons"
	},
	{
		name: "DocumentStatusBandCard",
		path: "documents/statuses/cards/DocumentStatusBandCard",
		styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard",
		importPath: "web-ui-components/lib/documents/statuses/cards"
	},
	{
		name: "FileInput",
		path: "documents/upload/FileInput",
		styleguidePath: "Documents/Upload/FileInput",
		importPath: "web-ui-components/lib/documents/upload"
	},
	{
		name: "AccountCheckboxCard",
		path: "finance/accounts/cards/AccountCheckboxCard",
		styleguidePath: "Finance/Accounts/Cards/AccountCheckboxCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLegacyUpdateCard",
		path: "finance/accounts/cards/AccountLegacyUpdateCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLegacyUpdateCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLinkCard",
		path: "finance/accounts/cards/AccountLinkCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLinkCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountPoolCard",
		path: "finance/accounts/cards/AccountPoolCard",
		styleguidePath: "Finance/Accounts/Cards/AccountPoolCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountSelectCard",
		path: "finance/accounts/cards/AccountSelectCard",
		styleguidePath: "Finance/Accounts/Cards/AccountSelectCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountStaticCard",
		path: "finance/accounts/cards/AccountStaticCard",
		styleguidePath: "Finance/Accounts/Cards/AccountStaticCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountAuthorisationPanel",
		path: "finance/accounts/panels/AccountAuthorisationPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountAuthorisationPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountBalancesSelectPanel",
		path: "finance/accounts/panels/AccountBalancesSelectPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountBalancesSelectPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountLegacyPanel",
		path: "finance/accounts/panels/AccountLegacyPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountLegacyPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPaymentStatusPanel",
		path: "finance/accounts/panels/AccountPaymentStatusPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPaymentStatusPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPoolTablePanel",
		path: "finance/accounts/panels/AccountPoolTablePanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPoolTablePanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountRadioCard",
		path: "finance/accounts/radios/AccountRadioCard",
		styleguidePath: "Finance/Accounts/Radios/AccountRadioCard",
		importPath: "web-ui-components/lib/finance/accounts/radios"
	},
	{
		name: "AccountPaymentReviewTable",
		path: "finance/accounts/tables/AccountPaymentReviewTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentReviewTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentSubmittedTable",
		path: "finance/accounts/tables/AccountPaymentSubmittedTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentSubmittedTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentTable",
		path: "finance/accounts/tables/AccountPaymentTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountSummaryTile",
		path: "finance/accounts/tiles/AccountSummaryTile",
		styleguidePath: "Finance/Accounts/Tiles/AccountSummaryTile",
		importPath: "web-ui-components/lib/finance/accounts/tiles"
	},
	{
		name: "CurrencySelect",
		path: "finance/currency/selects/CurrencySelect",
		styleguidePath: "Finance/Currency/Selects/CurrencySelect",
		importPath: "web-ui-components/lib/finance/currency/selects"
	},
	{
		name: "BlockField",
		path: "global/layout/BlockField",
		styleguidePath: "Global/Layout/BlockField",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "BlockFieldColumn",
		path: "global/layout/BlockFieldColumn",
		styleguidePath: "Global/Layout/BlockFieldColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "CenterImageContainer",
		path: "global/layout/CenterImageContainer",
		styleguidePath: "Global/Layout/CenterImageContainer",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Column",
		path: "global/layout/Column",
		styleguidePath: "Global/Layout/Column",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Container",
		path: "global/layout/Container",
		styleguidePath: "Global/Layout/Container",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexColumn",
		path: "global/layout/FlexColumn",
		styleguidePath: "Global/Layout/FlexColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexRow",
		path: "global/layout/FlexRow",
		styleguidePath: "Global/Layout/FlexRow",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Frame",
		path: "global/layout/Frame",
		styleguidePath: "Global/Layout/Frame",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "InternalSlot",
		path: "global/layout/InternalSlot",
		styleguidePath: "Global/Layout/InternalSlot",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "LeftAndRightAlignment",
		path: "global/layout/LeftAndRightAlignment",
		styleguidePath: "Global/Layout/LeftAndRightAlignment",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "PageLayout",
		path: "global/layout/PageLayout",
		styleguidePath: "Global/Layout/PageLayout",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "HeaderSection",
		path: "global/layout/Pages/HeaderSection",
		styleguidePath: "Global/Layout/Pages/HeaderSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ServicingSection",
		path: "global/layout/Pages/ServicingSection",
		styleguidePath: "Global/Layout/Pages/ServicingSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "WorkflowSection",
		path: "global/layout/Pages/WorkflowSection",
		styleguidePath: "Global/Layout/Pages/WorkflowSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ResponsiveLayoutPair",
		path: "global/layout/ResponsiveLayoutPair",
		styleguidePath: "Global/Layout/ResponsiveLayoutPair",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Row",
		path: "global/layout/Row",
		styleguidePath: "Global/Layout/Row",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "ContentContainer",
		path: "layout/containers/ContentContainer",
		styleguidePath: "Layout/Containers/ContentContainer",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "Main",
		path: "layout/containers/Main",
		styleguidePath: "Layout/Containers/Main",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "GenericAccordion",
		path: "layout/content/accordions/GenericAccordion",
		styleguidePath: "Layout/Content/Accordions/GenericAccordion",
		importPath: "web-ui-components/lib/layout/content/accordions"
	},
	{
		name: "StatusBanner",
		path: "layout/content/banners/StatusBanner",
		styleguidePath: "Layout/Content/Banners/StatusBanner",
		importPath: "web-ui-components/lib/layout/content/banners"
	},
	{
		name: "GenericDivider",
		path: "layout/content/breaks/GenericDivider",
		styleguidePath: "Layout/Content/Breaks/GenericDivider",
		importPath: "web-ui-components/lib/layout/content/breaks"
	},
	{
		name: "GenericModal",
		path: "layout/content/modals/GenericModal",
		styleguidePath: "Layout/Content/Modals/GenericModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "InformationModal",
		path: "layout/content/modals/InformationModal",
		styleguidePath: "Layout/Content/Modals/InformationModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "MultiButtonModal",
		path: "layout/content/modals/MultiButtonModal",
		styleguidePath: "Layout/Content/Modals/MultiButtonModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "BrandedPanel",
		path: "layout/content/panels/BrandedPanel",
		styleguidePath: "Layout/Content/Panels/BrandedPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ConditionalPanel",
		path: "layout/content/panels/ConditionalPanel",
		styleguidePath: "Layout/Content/Panels/ConditionalPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ContentRevealPanel",
		path: "layout/content/panels/ContentRevealPanel",
		styleguidePath: "Layout/Content/Panels/ContentRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "GenericPanel",
		path: "layout/content/panels/GenericPanel",
		styleguidePath: "Layout/Content/Panels/GenericPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "InformationRevealPanel",
		path: "layout/content/panels/InformationRevealPanel",
		styleguidePath: "Layout/Content/Panels/InformationRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellPanel",
		path: "layout/content/panels/ShellPanel",
		styleguidePath: "Layout/Content/Panels/ShellPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellSidebarPanel",
		path: "layout/content/panels/ShellSidebarPanel",
		styleguidePath: "Layout/Content/Panels/ShellSidebarPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SimplePanel",
		path: "layout/content/panels/SimplePanel",
		styleguidePath: "Layout/Content/Panels/SimplePanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "StatusPanel",
		path: "layout/content/panels/StatusPanel",
		styleguidePath: "Layout/Content/Panels/StatusPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SubformRevealPanel",
		path: "layout/content/panels/SubformRevealPanel",
		styleguidePath: "Layout/Content/Panels/SubformRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ToggleButtonPanel",
		path: "layout/content/panels/ToggleButtonPanel",
		styleguidePath: "Layout/Content/Panels/ToggleButtonPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ProcessingScreenTakeover",
		path: "layout/content/takeovers/ProcessingScreenTakeover",
		styleguidePath: "Layout/Content/Takeovers/ProcessingScreenTakeover",
		importPath: "web-ui-components/lib/layout/content/takeovers"
	},
	{
		name: "AttentionTile",
		path: "layout/content/tiles/AttentionTile",
		styleguidePath: "Layout/Content/Tiles/AttentionTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GuidanceTile",
		path: "layout/content/tiles/GuidanceTile",
		styleguidePath: "Layout/Content/Tiles/GuidanceTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "OutcomeTile",
		path: "layout/content/tiles/OutcomeTile",
		styleguidePath: "Layout/Content/Tiles/OutcomeTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "RecapTile",
		path: "layout/content/tiles/RecapTile",
		styleguidePath: "Layout/Content/Tiles/RecapTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "StandoutTile",
		path: "layout/content/tiles/StandoutTile",
		styleguidePath: "Layout/Content/Tiles/StandoutTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "ValidationMessageTile",
		path: "layout/content/tiles/ValidationMessageTile",
		styleguidePath: "Layout/Content/Tiles/ValidationMessageTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GridListToggle",
		path: "layout/content/views/GridListToggle",
		styleguidePath: "Layout/Content/Views/GridListToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GridViewToggle",
		path: "layout/content/views/GridViewToggle",
		styleguidePath: "Layout/Content/Views/GridViewToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GenericFieldWrapper",
		path: "layout/fieldWrappers/GenericFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GenericFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "GroupFieldWrapper",
		path: "layout/fieldWrappers/GroupFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GroupFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "MainFixedFooter",
		path: "layout/footers/MainFixedFooter",
		styleguidePath: "Layout/Footers/MainFixedFooter",
		importPath: "web-ui-components/lib/layout/footers"
	},
	{
		name: "Grid",
		path: "layout/grids/Grid",
		styleguidePath: "Layout/Grids/Grid",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "Inline",
		path: "layout/grids/Inline",
		styleguidePath: "Layout/Grids/Inline",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "ContainedHeader",
		path: "layout/headers/ContainedHeader",
		styleguidePath: "Layout/Headers/ContainedHeader",
		importPath: "web-ui-components/lib/layout/headers"
	},
	{
		name: "FixedFooter",
		path: "layout/sections/footers/FixedFooter",
		styleguidePath: "Layout/Sections/Footers/FixedFooter",
		importPath: "web-ui-components/lib/layout/sections/footers"
	},
	{
		name: "ApplicationFormShell",
		path: "layout/shells/ApplicationFormShell",
		styleguidePath: "Layout/Shells/ApplicationFormShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "DataManagementShell",
		path: "layout/shells/DataManagementShell",
		styleguidePath: "Layout/Shells/DataManagementShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "ShellInnerSpacer",
		path: "layout/shells/ShellInnerSpacer",
		styleguidePath: "Layout/Shells/ShellInnerSpacer",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "VerticalReviewTable",
		path: "layout/tables/VerticalReviewTable",
		styleguidePath: "Layout/Tables/VerticalReviewTable",
		importPath: "web-ui-components/lib/layout/tables"
	},
	{
		name: "NonUKAddressFieldset",
		path: "location/addresses/fieldsets/NonUKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/NonUKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressFieldset",
		path: "location/addresses/fieldsets/UKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/UKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressCaptureModule",
		path: "location/addresses/modules/UKAddressCaptureModule",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "UKAddressCaptureModule2",
		path: "location/addresses/modules/UKAddressCaptureModule2",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule2",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "BaseSelect",
		path: "location/places/selects/BaseSelect",
		styleguidePath: "Location/Places/Selects/BaseSelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "CountrySelect",
		path: "location/places/selects/CountrySelect",
		styleguidePath: "Location/Places/Selects/CountrySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "UKCitySelect",
		path: "location/places/selects/UKCitySelect",
		styleguidePath: "Location/Places/Selects/UKCitySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "AccordionItem",
		path: "molecules/accordions/Accordion/AccordionItem",
		styleguidePath: "Molecules/Accordions/Accordion/AccordionItem",
		importPath: "web-ui-components/lib/molecules/accordions/accordion"
	},
	{
		name: "Accordion",
		path: "molecules/accordions/Accordion",
		styleguidePath: "Molecules/Accordions/Accordion",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "AccordionTable",
		path: "molecules/accordions/AccordionTable",
		styleguidePath: "Molecules/Accordions/AccordionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ContentReveal",
		path: "molecules/accordions/ContentReveal",
		styleguidePath: "Molecules/Accordions/ContentReveal",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionPanel",
		path: "molecules/accordions/ExpansionPanel",
		styleguidePath: "Molecules/Accordions/ExpansionPanel",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionTable",
		path: "molecules/accordions/ExpansionTable",
		styleguidePath: "Molecules/Accordions/ExpansionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ButtonGroup",
		path: "molecules/buttons/ButtonGroup",
		styleguidePath: "Molecules/Buttons/ButtonGroup",
		importPath: "web-ui-components/lib/molecules/buttons"
	},
	{
		name: "SortingCardGroup",
		path: "molecules/card-groups/SortingCardGroup",
		styleguidePath: "Molecules/Card-groups/SortingCardGroup",
		importPath: "web-ui-components/lib/molecules/card-groups"
	},
	{
		name: "AccountCard",
		path: "molecules/cards/AccountCard",
		styleguidePath: "Molecules/Cards/AccountCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "AccountSummaryLinkCard",
		path: "molecules/cards/AccountSummaryLinkCard",
		styleguidePath: "Molecules/Cards/AccountSummaryLinkCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "DateCard",
		path: "molecules/cards/DateCard",
		styleguidePath: "Molecules/Cards/DateCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "PromoCard",
		path: "molecules/cards/PromoCard",
		styleguidePath: "Molecules/Cards/PromoCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "StackingCard",
		path: "molecules/cards/StackingCard",
		styleguidePath: "Molecules/Cards/StackingCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "Autocomplete",
		path: "molecules/forms/Autocomplete",
		styleguidePath: "Molecules/Forms/Autocomplete",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ConfirmationCheckbox",
		path: "molecules/forms/ConfirmationCheckbox",
		styleguidePath: "Molecules/Forms/ConfirmationCheckbox",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "DaySelector",
		path: "molecules/forms/DaySelector",
		styleguidePath: "Molecules/Forms/DaySelector",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "FieldBody",
		path: "molecules/forms/Field/FieldBody",
		styleguidePath: "Molecules/Forms/Field/FieldBody",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FieldHeader",
		path: "molecules/forms/Field/FieldHeader",
		styleguidePath: "Molecules/Forms/Field/FieldHeader",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FormField",
		path: "molecules/forms/Field/FormField",
		styleguidePath: "Molecules/Forms/Field/FormField",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "Field",
		path: "molecules/forms/Field",
		styleguidePath: "Molecules/Forms/Field",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "PasswordReveal",
		path: "molecules/forms/PasswordReveal",
		styleguidePath: "Molecules/Forms/PasswordReveal",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "RadioCardGroup",
		path: "molecules/forms/RadioCardGroup",
		styleguidePath: "Molecules/Forms/RadioCardGroup",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "Search",
		path: "molecules/forms/Search",
		styleguidePath: "Molecules/Forms/Search",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SearchForm",
		path: "molecules/forms/SearchForm",
		styleguidePath: "Molecules/Forms/SearchForm",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControl",
		path: "molecules/forms/SegmentedControl",
		styleguidePath: "Molecules/Forms/SegmentedControl",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControlItem",
		path: "molecules/forms/SegmentedControl/SegmentedControlItem",
		styleguidePath: "Molecules/Forms/SegmentedControl/SegmentedControlItem",
		importPath: "web-ui-components/lib/molecules/forms/segmentedControl"
	},
	{
		name: "SegmentedSlider",
		path: "molecules/forms/SegmentedSlider",
		styleguidePath: "Molecules/Forms/SegmentedSlider",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ValidationMessage",
		path: "molecules/forms/ValidationMessage",
		styleguidePath: "Molecules/Forms/ValidationMessage",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "IconTextDynamic",
		path: "molecules/icon-text-dynamic/IconTextDynamic",
		styleguidePath: "Molecules/IconTextDynamic/IconTextDynamic",
		importPath: "web-ui-components/lib/molecules/icon-text-dynamic"
	},
	{
		name: "IconText",
		path: "molecules/icon-text/IconText",
		styleguidePath: "Molecules/IconText/IconText",
		importPath: "web-ui-components/lib/molecules/icon-text"
	},
	{
		name: "BackAnchor",
		path: "molecules/navigation/BackAnchor",
		styleguidePath: "Molecules/Navigation/BackAnchor",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "BackButton",
		path: "molecules/navigation/BackButton",
		styleguidePath: "Molecules/Navigation/BackButton",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Utility",
		path: "molecules/navigation/Utility",
		styleguidePath: "Molecules/Navigation/Utility",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Alert",
		path: "molecules/nbas/Alert",
		styleguidePath: "Molecules/NBAS/Alert",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "Promo",
		path: "molecules/nbas/Promo",
		styleguidePath: "Molecules/NBAS/Promo",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "ContrastingFormPanel",
		path: "molecules/panels/ContrastingFormPanel",
		styleguidePath: "Molecules/Panels/ContrastingFormPanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "DocumentAction",
		path: "molecules/panels/DocumentAction",
		styleguidePath: "Molecules/Panels/DocumentAction",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "IconifiedBulletPoint",
		path: "molecules/panels/IconifiedBulletPoint",
		styleguidePath: "Molecules/Panels/IconifiedBulletPoint",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "Panel",
		path: "molecules/panels/Panel",
		styleguidePath: "Molecules/Panels/Panel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PanelBody",
		path: "molecules/panels/Panel/PanelBody",
		styleguidePath: "Molecules/Panels/Panel/PanelBody",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelFooter",
		path: "molecules/panels/Panel/PanelFooter",
		styleguidePath: "Molecules/Panels/Panel/PanelFooter",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelHeader",
		path: "molecules/panels/Panel/PanelHeader",
		styleguidePath: "Molecules/Panels/Panel/PanelHeader",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelSector",
		path: "molecules/panels/Panel/PanelSector",
		styleguidePath: "Molecules/Panels/Panel/PanelSector",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "SettingLink",
		path: "molecules/panels/SettingLink",
		styleguidePath: "Molecules/Panels/SettingLink",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "SubordinatePanel",
		path: "molecules/panels/SubordinatePanel",
		styleguidePath: "Molecules/Panels/SubordinatePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "TogglePanel",
		path: "molecules/panels/TogglePanel",
		styleguidePath: "Molecules/Panels/TogglePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PayeeCard",
		path: "molecules/payee-cards/PayeeCard",
		styleguidePath: "Molecules/PayeeCard/PayeeCard",
		importPath: "web-ui-components/lib/molecules/payee-cards"
	},
	{
		name: "PaymentReview",
		path: "molecules/payments/PaymentReview",
		styleguidePath: "Molecules/Payments/PaymentReview",
		importPath: "web-ui-components/lib/molecules/payments"
	},
	{
		name: "ProgressIndicator",
		path: "molecules/progress/ProgressIndicator",
		styleguidePath: "Molecules/Progress/ProgressIndicator",
		importPath: "web-ui-components/lib/molecules/progress"
	},
	{
		name: "ProgressIndicatorItem",
		path: "molecules/progress/ProgressIndicator/ProgressIndicatorItem",
		styleguidePath: "Molecules/Progress/ProgressIndicator/ProgressIndicatorItem",
		importPath: "web-ui-components/lib/molecules/progress/progressIndicator"
	},
	{
		name: "ComparisonTable",
		path: "molecules/tables/ComparisonTable",
		styleguidePath: "Molecules/Tables/ComparisonTable",
		importPath: "web-ui-components/lib/molecules/tables"
	},
	{
		name: "DataTable",
		path: "molecules/tables/Table/DataTable",
		styleguidePath: "Molecules/Tables/Table/DataTable",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "Table",
		path: "molecules/tables/Table/Table",
		styleguidePath: "Molecules/Tables/Table/Table",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBody",
		path: "molecules/tables/Table/TableBody",
		styleguidePath: "Molecules/Tables/Table/TableBody",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBodyData",
		path: "molecules/tables/Table/TableBodyData",
		styleguidePath: "Molecules/Tables/Table/TableBodyData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHead",
		path: "molecules/tables/Table/TableHead",
		styleguidePath: "Molecules/Tables/Table/TableHead",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHeadData",
		path: "molecules/tables/Table/TableHeadData",
		styleguidePath: "Molecules/Tables/Table/TableHeadData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableRow",
		path: "molecules/tables/Table/TableRow",
		styleguidePath: "Molecules/Tables/Table/TableRow",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "SectionHeading",
		path: "molecules/text/SectionHeading",
		styleguidePath: "Molecules/Text/SectionHeading",
		importPath: "web-ui-components/lib/molecules/text"
	},
	{
		name: "ConfirmationTile",
		path: "molecules/tile/ConfirmationTile",
		styleguidePath: "Molecules/Tile/ConfirmationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "ExclamationTile",
		path: "molecules/tile/ExclamationTile",
		styleguidePath: "Molecules/Tile/ExclamationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "HighlightTile",
		path: "molecules/tile/HighlightTile",
		styleguidePath: "Molecules/Tile/HighlightTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "IconTile",
		path: "molecules/tile/IconTile",
		styleguidePath: "Molecules/Tile/IconTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "NumberedTile",
		path: "molecules/tile/NumberedTile",
		styleguidePath: "Molecules/Tile/NumberedTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "Tile",
		path: "molecules/tile/Tile",
		styleguidePath: "Molecules/Tile/Tile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "TileSector",
		path: "molecules/tile/Tile/TileSector",
		styleguidePath: "Molecules/Tile/Tile/TileSector",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "TileSegment",
		path: "molecules/tile/Tile/TileSegment",
		styleguidePath: "Molecules/Tile/Tile/TileSegment",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "ToggleOption",
		path: "molecules/toggle/ToggleOption",
		styleguidePath: "Molecules/Toggle/ToggleOption",
		importPath: "web-ui-components/lib/molecules/toggle"
	},
	{
		name: "PromoAnchor",
		path: "navigation/anchors/PromoAnchor",
		styleguidePath: "Navigation/Anchors/PromoAnchor",
		importPath: "web-ui-components/lib/navigation/anchors"
	},
	{
		name: "NavigationButton",
		path: "navigation/buttons/NavigationButton",
		styleguidePath: "Navigation/Buttons/NavigationButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "NavigationButtonGroup",
		path: "navigation/buttons/NavigationButtonGroup",
		styleguidePath: "Navigation/Buttons/NavigationButtonGroup",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "PromoButton",
		path: "navigation/buttons/PromoButton",
		styleguidePath: "Navigation/Buttons/PromoButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "ProgressStepper",
		path: "navigation/indicators/ProgressStepper",
		styleguidePath: "Navigation/Indicators/ProgressStepper",
		importPath: "web-ui-components/lib/navigation/indicators"
	},
	{
		name: "VerticalMenu",
		path: "navigation/menus/VerticalMenu",
		styleguidePath: "Navigation/Menus/VerticalMenu",
		importPath: "web-ui-components/lib/navigation/menus"
	},
	{
		name: "MainNavLink",
		path: "navigation/nav-links/MainNavLink",
		styleguidePath: "Navigation/Nav-links/MainNavLink",
		importPath: "web-ui-components/lib/navigation/nav-links"
	},
	{
		name: "Paginator",
		path: "navigation/pagination/Paginator",
		styleguidePath: "Navigation/Pagination/Paginator",
		importPath: "web-ui-components/lib/navigation/pagination"
	},
	{
		name: "PaginatorNextButton",
		path: "navigation/pagination/Paginator/PaginatorNextButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorNextButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPageButton",
		path: "navigation/pagination/Paginator/PaginatorPageButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPageButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPreviousButton",
		path: "navigation/pagination/Paginator/PaginatorPreviousButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPreviousButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "MainSiteNav",
		path: "navigation/site-navs/MainSiteNav",
		styleguidePath: "Navigation/Site-navs/MainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "MobileMainSiteNav",
		path: "navigation/site-navs/MobileMainSiteNav",
		styleguidePath: "Navigation/Site-navs/MobileMainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNav",
		path: "navigation/site-navs/UtilityNav",
		styleguidePath: "Navigation/Site-navs/UtilityNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNavButton",
		path: "navigation/site-navs/UtilityNavButton",
		styleguidePath: "Navigation/Site-navs/UtilityNavButton",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "TabCard",
		path: "navigation/tab-cards/TabCard",
		styleguidePath: "Navigation/Tab-cards/TabCard",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardBlock",
		path: "navigation/tab-cards/TabCardBlock",
		styleguidePath: "Navigation/Tab-cards/TabCardBlock",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardSmall",
		path: "navigation/tab-cards/TabCardSmall",
		styleguidePath: "Navigation/Tab-cards/TabCardSmall",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabGroup",
		path: "navigation/tab-group/TabGroup",
		styleguidePath: "Navigation/Tab-group/TabGroup",
		importPath: "web-ui-components/lib/navigation/tab-group"
	},
	{
		name: "TransferTakeover",
		path: "navigation/takeovers/TransferTakeover",
		styleguidePath: "Navigation/Takeovers/TransferTakeover",
		importPath: "web-ui-components/lib/navigation/takeovers"
	},
	{
		name: "Card",
		path: "organisms/cards/Card",
		styleguidePath: "Organisms/Cards/Card",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "DistinctiveLinkCard",
		path: "organisms/cards/DistinctiveLinkCard",
		styleguidePath: "Organisms/Cards/DistinctiveLinkCard",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "FilterAction",
		path: "organisms/filters/Filter/FilterActionGroup/FilterAction",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup/FilterAction",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterActionGroup"
	},
	{
		name: "FilterActionGroup",
		path: "organisms/filters/Filter/FilterActionGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSector",
		path: "organisms/filters/Filter/FilterSector",
		styleguidePath: "Organisms/Filters/Filter/FilterSector",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSegment",
		path: "organisms/filters/Filter/FilterSegmentGroup/FilterSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup/FilterSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSegmentGroup"
	},
	{
		name: "FilterSegmentGroup",
		path: "organisms/filters/Filter/FilterSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSubSegment",
		path: "organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSubSegmentGroup"
	},
	{
		name: "FilterSubSegmentGroup",
		path: "organisms/filters/Filter/FilterSubSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "Filter",
		path: "organisms/filters/Filter",
		styleguidePath: "Organisms/Filters/Filter",
		importPath: "web-ui-components/lib/organisms/filters"
	},
	{
		name: "GlobalHeader",
		path: "organisms/global/GlobalHeader",
		styleguidePath: "Organisms/Global/GlobalHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "HeroHeader",
		path: "organisms/global/HeroHeader",
		styleguidePath: "Organisms/Global/HeroHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "CentredModal",
		path: "organisms/modals/CentredModal",
		styleguidePath: "Organisms/Modals/CentredModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ConfirmationModal",
		path: "organisms/modals/ConfirmationModal",
		styleguidePath: "Organisms/Modals/ConfirmationModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "Loader",
		path: "organisms/modals/Loader",
		styleguidePath: "Organisms/Modals/Loader",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ModalBody",
		path: "organisms/modals/Modal/ModalBody",
		styleguidePath: "Organisms/Modals/Modal/ModalBody",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalContainer",
		path: "organisms/modals/Modal/ModalContainer",
		styleguidePath: "Organisms/Modals/Modal/ModalContainer",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalHeader",
		path: "organisms/modals/Modal/ModalHeader",
		styleguidePath: "Organisms/Modals/Modal/ModalHeader",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "Modal",
		path: "organisms/modals/Modal",
		styleguidePath: "Organisms/Modals/Modal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "UnfinishedWorkModal",
		path: "organisms/modals/UnfinishedWorkModal",
		styleguidePath: "Organisms/Modals/UnfinishedWorkModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "DisableTakeover",
		path: "organisms/takeovers/DisableTakeover",
		styleguidePath: "Organisms/Takeovers/DisableTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "LoadingLocalTakeover",
		path: "organisms/takeovers/LoadingLocalTakeover",
		styleguidePath: "Organisms/Takeovers/LoadingLocalTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "Timeline",
		path: "organisms/timelines/Timeline",
		styleguidePath: "Organisms/Timeline/Timeline",
		importPath: "web-ui-components/lib/organisms/timelines"
	},
	{
		name: "ProductSelector",
		path: "products/selection/ProductSelector",
		styleguidePath: "Products/Selection/ProductSelector",
		importPath: "web-ui-components/lib/products/selection"
	},
	{
		name: "EmailCreationInput",
		path: "security/authentication/inputs/EmailCreationInput",
		styleguidePath: "Security/Authentication/Inputs/EmailCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "PasswordCreationInput",
		path: "security/authentication/inputs/PasswordCreationInput",
		styleguidePath: "Security/Authentication/Inputs/PasswordCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "CallButton",
		path: "telephony/Buttons/CallButton",
		styleguidePath: "Telephony/Buttons/CallButton",
		importPath: "web-ui-components/lib/telephony/buttons"
	},
	{
		name: "CallStatus",
		path: "telephony/Statuses/CallStatus",
		styleguidePath: "Telephony/Statuses/CallStatus",
		importPath: "web-ui-components/lib/telephony/statuses"
	},
	{
		name: "LogoDisplay",
		path: "transactions/logo/LogoDisplay",
		styleguidePath: "Transactions/Logo/LogoDisplay",
		importPath: "web-ui-components/lib/transactions/logo"
	},
	{
		name: "Footer",
		path: "typography/ancillary/Footer",
		styleguidePath: "Typography/Ancillary/Footer",
		importPath: "web-ui-components/lib/typography/ancillary"
	},
	{
		name: "LargeBody",
		path: "typography/body/LargeBody",
		styleguidePath: "Typography/Body/LargeBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SecondaryBody",
		path: "typography/body/SecondaryBody",
		styleguidePath: "Typography/Body/SecondaryBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SignificantBody",
		path: "typography/body/SignificantBody",
		styleguidePath: "Typography/Body/SignificantBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SmallestBody",
		path: "typography/body/SmallestBody",
		styleguidePath: "Typography/Body/SmallestBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "StandardBody",
		path: "typography/body/StandardBody",
		styleguidePath: "Typography/Body/StandardBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SubBody",
		path: "typography/body/SubBody",
		styleguidePath: "Typography/Body/SubBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "VisuallyHiddenBody",
		path: "typography/body/VisuallyHiddenBody",
		styleguidePath: "Typography/Body/VisuallyHiddenBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "PageHeading",
		path: "typography/headings/PageHeading",
		styleguidePath: "Typography/Headings/PageHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SectionHeading",
		path: "typography/headings/SectionHeading",
		styleguidePath: "Typography/Headings/SectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubHeading",
		path: "typography/headings/SubHeading",
		styleguidePath: "Typography/Headings/SubHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubsectionHeading",
		path: "typography/headings/SubsectionHeading",
		styleguidePath: "Typography/Headings/SubsectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "LargeHero",
		path: "typography/heros/LargeHero",
		styleguidePath: "Typography/Heros/LargeHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "StandardHero",
		path: "typography/heros/StandardHero",
		styleguidePath: "Typography/Heros/StandardHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "IndicativeHighlight",
		path: "typography/highlights/IndicativeHighlight",
		styleguidePath: "Typography/Highlights/IndicativeHighlight",
		importPath: "web-ui-components/lib/typography/highlights"
	},
	{
		name: "StateIndicator",
		path: "typography/indicators/StateIndicator",
		styleguidePath: "Typography/Indicators/StateIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "StepIndicator",
		path: "typography/indicators/StepIndicator",
		styleguidePath: "Typography/Indicators/StepIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "FieldLabel",
		path: "typography/labels/FieldLabel",
		styleguidePath: "Typography/Labels/FieldLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "ProminentLabel",
		path: "typography/labels/ProminentLabel",
		styleguidePath: "Typography/Labels/ProminentLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "StandardLabel",
		path: "typography/labels/StandardLabel",
		styleguidePath: "Typography/Labels/StandardLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "SubLabel",
		path: "typography/labels/SubLabel",
		styleguidePath: "Typography/Labels/SubLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "BulletList",
		path: "typography/lists/BulletList",
		styleguidePath: "Typography/Lists/BulletList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NegativeList",
		path: "typography/lists/NegativeList",
		styleguidePath: "Typography/Lists/NegativeList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NumberList",
		path: "typography/lists/NumberList",
		styleguidePath: "Typography/Lists/NumberList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "PositiveList",
		path: "typography/lists/PositiveList",
		styleguidePath: "Typography/Lists/PositiveList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "TickList",
		path: "typography/lists/TickList",
		styleguidePath: "Typography/Lists/TickList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "Identifier",
		path: "typography/modifiers/Identifier",
		styleguidePath: "Typography/Modifiers/Identifier",
		importPath: "web-ui-components/lib/typography/modifiers"
	},
	{
		name: "AbbreviatedTag",
		path: "typography/tags/AbbreviatedTag",
		styleguidePath: "Typography/Tags/AbbreviatedTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "StatusTag",
		path: "typography/tags/StatusTag",
		styleguidePath: "Typography/Tags/StatusTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "ValueTag",
		path: "typography/tags/ValueTag",
		styleguidePath: "Typography/Tags/ValueTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "MostProminentValue",
		path: "typography/values/MostProminentValue",
		styleguidePath: "Typography/Values/MostProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "ProminentValue",
		path: "typography/values/ProminentValue",
		styleguidePath: "Typography/Values/ProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "StandardValue",
		path: "typography/values/StandardValue",
		styleguidePath: "Typography/Values/StandardValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "VeryProminentValue",
		path: "typography/values/VeryProminentValue",
		styleguidePath: "Typography/Values/VeryProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "UserStatusBandCard",
		path: "users/business-users/cards/UserStatusBandCard",
		styleguidePath: "Users/Business-users/Cards/UserStatusBandCard",
		importPath: "web-ui-components/lib/users/business-users/cards"
	}
];

var deprecated = [{
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "TallRadioCard",
	path: "src/actions/radios/TallRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "WideRadioCard",
	path: "src/actions/radios/WideRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}],
	deprecationVersion: "7.3.0",
	deprecationDate: "August 30 2018"
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "19.0.0",
	deprecationDate: "May 03 2019"
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "20.0.0",
	deprecationDate: "May 15 2019"
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "25.1.0",
	deprecationDate: "March 23 2020"
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}],
	deprecationVersion: "22.1.0",
	deprecationDate: "July 17 2019"
}, {
	name: "CenterImageContainer",
	path: "src/global/layout/CenterImageContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids",
			variant: "Centered"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.2.2",
	deprecationDate: "July 31 2020"
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.7.0",
	deprecationDate: "December 16 2020"
}, {
	name: "ShellSidebarPanel",
	path: "src/layout/content/panels/ShellSidebarPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ShellPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GridViewToggle",
	path: "src/layout/content/views/GridViewToggle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GridListToggle",
			path: "Layout/Content/Views"
		}
	}],
	deprecationVersion: "28.3.0",
	deprecationDate: "January 21 2022"
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "24.1.0",
	deprecationDate: "March 05 2020"
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}, {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions/GenericAccordion"
		}, {
			name: "InformationRevealPanel",
			path: "Layout/Content/Panels"
		}]
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "SegmentedSlider",
	path: "src/molecules/forms/SegmentedSlider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SliderInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "28.4.0",
	deprecationDate: "June 21 2022"
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}],
	deprecationVersion: "22.22.0",
	deprecationDate: "January 20 2020"
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}],
	deprecationVersion: "6.4.0",
	deprecationDate: "August 03 2018"
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}],
	deprecationVersion: "25.5.0",
	deprecationDate: "May 13 2020"
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}],
	deprecationVersion: "22.12.0",
	deprecationDate: "September 27 2019"
}, {
	name: "ContrastingFormPanel",
	path: "src/molecules/panels/ContrastingFormPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericPanel",
			path: "Layout/Content/Panels",
			variant: "Interaction"
		}
	}],
	deprecationVersion: "33.3.0",
	deprecationDate: "April 03 2024"
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	deprecationVersion: "NO RELEASE VERSION FOUND",
	deprecationDate: "NO RELEASE DATE FOUND"
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}],
	deprecationVersion: "27.8.0",
	deprecationDate: "January 29 2021"
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}];

/* eslint-disable no-console */

var deprecatedDictComponents = {};
var deprecatedDictProps = {};
var timeoutDelay = 100;

var CONSOLE_DEPRECATION_MESSAGE_START = 'Deprecation: web-ui-components';

var DeprecationWarnings = {
	logComponent: function logComponent(componentName) {
		var deprecatedComponentObj = componentPaths.find(function (_ref) {
			var name = _ref.name;
			return name === componentName;
		});
		var oldPath = deprecatedComponentObj.styleguidePath;
		deprecatedComponentObj = deprecated.find(function (_ref2) {
			var name = _ref2.name;
			return name.includes(componentName);
		});

		var depreactionReplacements = deprecatedComponentObj.deprecations[0].replacements;
		var hasMultipleReplacements = Array.isArray(depreactionReplacements);
		var newPath = hasMultipleReplacements ? depreactionReplacements.map(function (replacement) {
			return replacement.path + '/' + replacement.name;
		}) : depreactionReplacements.path + '/' + depreactionReplacements.name;

		deprecatedDictComponents[componentName] = { oldPath: oldPath, newPath: newPath };
	},
	logIcon: function logIcon(componentName, deprecatedIcon) {
		var deprecatedComponentObj = componentPaths.find(function (_ref3) {
			var name = _ref3.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		var oldPath = path + ': ' + deprecatedIcon;
		var newPath = path + ': ' + deprecatedIcon;
		var iconName = componentName + ': ' + deprecatedIcon;

		deprecatedDictComponents[iconName] = { oldPath: oldPath, newPath: newPath };
	},
	logProp: function logProp(packageJson, description) {
		var _packageJson$main$spl = packageJson.main.split('.'),
		    _packageJson$main$spl2 = slicedToArray(_packageJson$main$spl, 1),
		    componentName = _packageJson$main$spl2[0];

		var deprecatedComponentObj = componentPaths.find(function (_ref4) {
			var name = _ref4.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		deprecatedDictProps[componentName] = { path: path, description: description };
	},
	report: function report() {
		setTimeout(function () {
			var numberOfDeprecations = Object.keys(deprecatedDictComponents).length + Object.keys(deprecatedDictProps).length;
			if (numberOfDeprecations > 0) {
				console.groupCollapsed('Web UI Components Deprecation Warnings. Total: ' + numberOfDeprecations);

				console.groupCollapsed('Components. Total: ' + Object.keys(deprecatedDictComponents).length);
				Object.entries(deprecatedDictComponents).forEach(function (_ref5) {
					var _ref6 = slicedToArray(_ref5, 2),
					    componentName = _ref6[0],
					    info = _ref6[1];

					var oldPath = info.oldPath,
					    newPath = info.newPath;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', oldPath);

					var hasMultipleReplacements = Array.isArray(newPath);
					if (hasMultipleReplacements) {
						newPath.map(function (replacement, index) {
							return console.warn('Replacement ' + (index + 1) + ':', replacement);
						});
					} else {
						console.warn('Replacement:', newPath);
					}
					console.groupEnd();
				});
				console.groupEnd();

				console.groupCollapsed('Props. Total: ' + Object.keys(deprecatedDictProps).length);
				Object.entries(deprecatedDictProps).forEach(function (_ref7) {
					var _ref8 = slicedToArray(_ref7, 2),
					    componentName = _ref8[0],
					    info = _ref8[1];

					var path = info.path,
					    description = info.description;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', path);
					console.warn('Reason:', description);
					console.groupEnd();
				});
				console.groupEnd();

				console.groupEnd();
				deprecatedDictComponents = {};
				deprecatedDictProps = {};
			}
		}, timeoutDelay);
	},
	warn: function warn(message) {
		return console.warn(CONSOLE_DEPRECATION_MESSAGE_START + ' -> ' + message);
	}
};

Object.freeze(DeprecationWarnings);

var main$5 = "FieldHeader.js";
var deprecations$3 = [{
	replacements: {
		name: "GenericFieldWrapper",
		path: "Layout/Field-wrappers"
	}
}];
var packageJson$5 = {
	main: main$5,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$3
};

var FieldHeader = function FieldHeader(_ref) {
	var name = _ref.name,
	    title = _ref.title,
	    titleText = _ref.titleText,
	    description = _ref.description,
	    hasError = _ref.hasError,
	    validationMessage = _ref.validationMessage,
	    supplement = _ref.supplement;

	if (title !== undefined) {
		DeprecationWarnings.logProp(packageJson$5, 'title prop deprecated in favour of titleText prop.');
	}

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$5, hasCustomMargins: true },
		React.createElement(
			'div',
			{ className: 'c-m-form-field__header' },
			(titleText || title) && React.createElement(
				Label,
				{ htmlFor: name },
				React.createElement(
					'span',
					{ className: 'c-a-label__title' },
					titleText || title
				),
				supplement && React.createElement(
					'span',
					{ className: 'c-a-label__supplement' },
					supplement
				)
			),
			description && React.createElement(
				FieldDescription,
				null,
				description
			),
			hasError && React.createElement(ValidationMessageTileWithTheme, { messageText: validationMessage })
		)
	);
};

FieldHeader.propTypes = {
	name: PropTypes.string.isRequired,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Title text. */
	titleText: PropTypes.string,
	description: PropTypes.string,
	hasError: PropTypes.bool,
	validationMessage: PropTypes.string,
	supplement: PropTypes.string
};

FieldHeader.defaultProps = {
	hasError: false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\tmax-width: 100%;\n'], ['\n\tmax-width: 100%;\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tmargin-right: 0;\n\tmax-width: 100%;\n\tmin-height: 48px;\n'], ['\n\tdisplay: flex;\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tmargin-right: 0;\n\tmax-width: 100%;\n\tmin-height: 48px;\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\tappearance: none;\n\tbackground: none;\n\tborder: none;\n\theight: 48px;\n\tpadding: ', ' ', ';\n'], ['\n\tappearance: none;\n\tbackground: none;\n\tborder: none;\n\theight: 48px;\n\tpadding: ', ' ', ';\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground-color: hsl(0, 0%, 97%);\n\tborder-color: hsl(240, 2%, 89%);\n\tborder-radius: 100%;\n\tborder-style: solid;\n\tborder-width: 2px;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\theight: 32px;\n\twidth: 32px;\n\n\tsvg {\n\t\tfill: hsl(225, 2%, 44%);\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n'], ['\n\talign-items: center;\n\tbackground-color: hsl(0, 0%, 97%);\n\tborder-color: hsl(240, 2%, 89%);\n\tborder-radius: 100%;\n\tborder-style: solid;\n\tborder-width: 2px;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\theight: 32px;\n\twidth: 32px;\n\n\tsvg {\n\t\tfill: hsl(225, 2%, 44%);\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject5$2 = taggedTemplateLiteral(['\n\tdisplay: initial;\n\twidth: 100%;\n'], ['\n\tdisplay: initial;\n\twidth: 100%;\n']);

var StyledFieldBody = styled(FieldBody)(_templateObject$6);

var StyledAutoCompleteWrapper = styled('div')(_templateObject2$5);

var StyledButton$1 = styled('button')(_templateObject3$3, spacing.HALF, spacing.ONE_AND_HALF);

var StyledButtonIcon = styled('div')(_templateObject4$2);

var StyledReactAutoCompleteWrapper = styled('div')(_templateObject5$2);

var Autocomplete = function Autocomplete(_ref) {
	var getItemValue = _ref.getItemValue,
	    items = _ref.items,
	    _onChange = _ref.onChange,
	    onClear = _ref.onClear,
	    onSelect = _ref.onSelect,
	    placeholder = _ref.placeholder,
	    renderItem = _ref.renderItem,
	    theme = _ref.theme,
	    value = _ref.value,
	    rest = objectWithoutProperties(_ref, ['getItemValue', 'items', 'onChange', 'onClear', 'onSelect', 'placeholder', 'renderItem', 'theme', 'value']);

	var CrossSolidSmallIcon = getCrossSolidSmall(theme.name);
	return React.createElement(
		Field,
		null,
		React.createElement(FieldHeader, { name: 'Search' }),
		React.createElement(
			StyledFieldBody,
			null,
			React.createElement(
				StyledAutoCompleteWrapper,
				null,
				React.createElement(
					StyledReactAutoCompleteWrapper,
					null,
					React.createElement(ReactAutocomplete, _extends({
						inputProps: {
							autoFocus: true,
							placeholder: placeholder,
							type: 'search'
						},
						getItemValue: getItemValue,
						items: items,
						onSelect: onSelect,
						onChange: function onChange(event) {
							return _onChange(event.target.value);
						},
						value: value,
						renderItem: renderItem,
						wrapperStyle: {},
						autoHighlight: false
					}, rest))
				),
				React.createElement(
					StyledButton$1,
					{ width: 'flush', onClick: onClear },
					React.createElement(
						StyledButtonIcon,
						null,
						React.createElement(CrossSolidSmallIcon, { className: 'c-a-icon' })
					)
				)
			)
		)
	);
};

Autocomplete.propTypes = {
	getItemValue: PropTypes.func,
	items: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		label: PropTypes.string
	})).isRequired,
	onChange: PropTypes.func.isRequired,
	onClear: PropTypes.func.isRequired,
	onSelect: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	renderInput: PropTypes.func,
	renderItem: PropTypes.func,
	renderMenu: PropTypes.func,
	value: PropTypes.string.isRequired
};

Autocomplete.defaultProps = {
	getItemValue: function getItemValue(item) {
		return item.label;
	},
	renderInput: function renderInput(inputProps) {
		return React.createElement('input', _extends({ className: 'c-a-input c-a-input--text' }, inputProps));
	},
	renderItem: function renderItem(item, isHighlighted) {
		var classNames = classnames('c-m-autocomplete-results__list-item', {
			'is-active': isHighlighted
		});
		return React.createElement(
			'li',
			{ key: 'autocomplete-item-' + item.id, className: classNames },
			React.createElement(
				'span',
				null,
				item.label
			)
		);
	},
	renderMenu: function renderMenu(items, _, style) {
		if (!items || items.length === 0) {
			return React.createElement('div', null);
		}
		return React.createElement(
			'div',
			{ className: 'c-m-autocomplete-results has-indicator', style: _extends({}, style) },
			React.createElement(
				'div',
				{ className: 'c-m-autocomplete-results__header u-visually-hidden' },
				React.createElement(
					'h4',
					{ className: 'c-m-autocomplete-results__title' },
					'Search results'
				)
			),
			React.createElement(
				'div',
				{ className: 'c-m-autocomplete-results__body' },
				React.createElement(
					'ul',
					{ className: 'c-m-autocomplete-results__list' },
					items
				)
			)
		);
	}
};

var WrappedAutocomplete = withTheme(Autocomplete);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString_1(prefix) + id;
}

var uniqueId_1 = uniqueId;

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CheckboxIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.136 59.588L73.4 21l8.1 7.823-44.935 46.532-.157-.15-.15.155L14.5 54.35l7.823-8.1 13.813 13.338z" }));
});

var InputClickable = function (_Component) {
	inherits(InputClickable, _Component);

	function InputClickable(props) {
		classCallCheck(this, InputClickable);

		var _this = possibleConstructorReturn(this, (InputClickable.__proto__ || Object.getPrototypeOf(InputClickable)).call(this, props));

		_this.inputRef = null;
		return _this;
	}

	createClass(InputClickable, [{
		key: 'focus',
		value: function focus() {
			if (this.inputRef) {
				this.inputRef.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    label = _props.label,
			    id = _props.id,
			    type = _props.type,
			    name = _props.name,
			    onChange = _props.onChange,
			    checked = _props.checked,
			    body = _props.body,
			    media = _props.media,
			    disabled = _props.disabled,
			    className = _props.className,
			    suffix = _props.suffix,
			    rest = objectWithoutProperties(_props, ['label', 'id', 'type', 'name', 'onChange', 'checked', 'body', 'media', 'disabled', 'className', 'suffix']);


			var mainClassName = 'c-a-' + type + (media ? '-icon' : '');
			return React.createElement(
				'div',
				{ className: classnames(mainClassName, className) },
				React.createElement('input', _extends({
					id: id,
					name: name,
					type: type,
					onChange: onChange,
					checked: checked,
					disabled: disabled,
					ref: function ref(component) {
						_this2.inputRef = component;
					}
				}, rest)),
				React.createElement(
					'label',
					{ htmlFor: id },
					media && React.createElement(
						'span',
						{ className: mainClassName + '__media' },
						media
					),
					React.createElement(
						'span',
						{ className: mainClassName + '__body' },
						body,
						React.createElement(
							'span',
							{ className: mainClassName + '__title' },
							React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									label,
									' ',
									suffix
								)
							)
						)
					)
				)
			);
		}
	}]);
	return InputClickable;
}(Component);

InputClickable.propTypes = {
	body: PropTypes.node,
	checked: PropTypes.bool.isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	media: PropTypes.node,
	onChange: PropTypes.func.isRequired,
	type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
	suffix: PropTypes.oneOfType([PropTypes.element, PropTypes.node])
};

InputClickable.defaultProps = {
	disabled: false
};

var main$6 = "Checkbox.js";
var deprecations$4 = [{
	replacements: {
		name: "GenericCheckbox",
		path: "Data/Capture/Checkboxes"
	}
}];
var packageJson$6 = {
	main: main$6,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$4
};

var Checkbox = function (_Component) {
	inherits(Checkbox, _Component);

	function Checkbox(props) {
		classCallCheck(this, Checkbox);

		var _this = possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(Checkbox, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    label = _props.label,
			    id = _props.id,
			    name = _props.name,
			    onClick = _props.onClick,
			    onChange = _props.onChange,
			    checked = _props.checked,
			    block = _props.block,
			    fullWidth = _props.fullWidth,
			    disabled = _props.disabled,
			    suffix = _props.suffix,
			    noIndicator = _props.noIndicator,
			    isSquared = _props.isSquared;


			if (onClick) {
				DeprecationWarnings.logProp(packageJson$6, 'Explicitly using onClick prop is deprecated and will be removed. Future implementations should use onChange prop for both onClick & onChange events. Only changed data will be passed.');
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$6, hasCustomMargins: true, layout: 'inline-block' },
				React.createElement(InputClickable, {
					id: id,
					label: label,
					name: name,
					type: 'checkbox',
					onClick: onClick,
					onChange: onChange,
					checked: checked,
					disabled: disabled,
					className: classnames({
						'c-a-checkbox--full-width': fullWidth,
						'c-a-checkbox--block': block,
						'c-a-checkbox--no-indicator': noIndicator,
						'c-a-checkbox--squared': isSquared
					}),
					body: React.createElement(CheckboxIcon, { className: 'c-a-icon' }),
					suffix: suffix,
					ref: function ref(component) {
						_this2.refInput = component;
					}
				})
			);
		}
	}]);
	return Checkbox;
}(Component);

Checkbox.propTypes = {
	block: PropTypes.bool,
	checked: PropTypes.bool.isRequired,
	disabled: PropTypes.bool,
	fullWidth: PropTypes.bool,
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	suffix: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
	noIndicator: PropTypes.bool,
	isSquared: PropTypes.bool
};

Checkbox.defaultProps = {
	block: false,
	fullWidth: false,
	disabled: false
};

var main$7 = "TextStyled.js";
var deprecations$5 = [{
	replacements: {
		name: "Typography",
		path: "Typography"
	}
}];
var packageJson$7 = {
	main: main$7,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$5
};

var TextStyled = function TextStyled(_ref) {
	var size = _ref.size,
	    className = _ref.className,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$7, hasCustomMargins: true },
		React.createElement(
			'div',
			{ className: classnames('o-type-size-' + size, className) },
			children
		)
	);
};

TextStyled.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	size: PropTypes.oneOf(['lewis', 'skye', 'shetland', 'mull', 'islay', 'orkney', 'arran', 'jura', 'uist', 'bute', 'cumbrae']).isRequired
};

var main$8 = "ValidationMessage.js";
var deprecations$6 = [{
	replacements: {
		name: "ValidationMessageTile",
		path: "Layout/Tiles"
	}
}];
var packageJson$8 = {
	main: main$8,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$6
};

// eslint-disable-next-line react/prop-types
var ValidationMessage = function ValidationMessage(_ref) {
	var value = _ref.value,
	    className = _ref.className,
	    hasIcon = _ref.hasIcon,
	    theme = _ref.theme;

	var ExclamationCircleLarge = getExclamationCircleLarge(theme.name);
	var props = {};
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$8, hasCustomMargins: true },
		React.createElement(
			'div',
			_extends({}, props, { className: classnames('c-m-validation-message', className) }),
			hasIcon && React.createElement(
				'div',
				{ className: 'c-m-validation-message__icon' },
				React.createElement(ExclamationCircleLarge, { className: 'c-a-icon' })
			),
			React.createElement(
				TextStyled,
				{ size: 'uist', className: 'c-m-validation-message__content' },
				React.createElement(
					'p',
					{ className: 'u-margin-bottom-0' },
					value
				)
			)
		)
	);
};

ValidationMessage.propTypes = {
	className: PropTypes.string,
	hasIcon: PropTypes.bool,
	value: PropTypes.string.isRequired
};

ValidationMessage.defaultProps = {
	hasIcon: true
};
var ValidationMessageWithTheme = withTheme(ValidationMessage);

var main$9 = "ConfirmationCheckbox.js";
var deprecations$7 = [{
	replacements: {
		name: "StandaloneCheckbox",
		path: "Data/Capture/Checkboxes"
	}
}];
var packageJson$9 = {
	main: main$9,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$7
};

var ConfirmationCheckbox = function ConfirmationCheckbox(_ref) {
	var isChecked = _ref.isChecked,
	    isDisabled = _ref.isDisabled,
	    label = _ref.label,
	    hasError = _ref.hasError,
	    validationMessage = _ref.validationMessage,
	    onChange = _ref.onChange;

	var id = uniqueId_1('ConfirmationCheckbox-');
	var changeHandler = function changeHandler() {
		return onChange(isChecked);
	};

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$9, hasCustomMargins: true },
		React.createElement(
			Field,
			null,
			hasError && React.createElement(ValidationMessageWithTheme, { value: validationMessage }),
			React.createElement(Checkbox, { checked: isChecked, disabled: isDisabled, fullWidth: true, id: id, label: label, onChange: changeHandler })
		)
	);
};

ConfirmationCheckbox.propTypes = {
	/** Sets the checked attribute. */
	isChecked: PropTypes.bool,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Sets the label text. This is required to give a descriptive meaning to the input. */
	label: PropTypes.string.isRequired,
	/** Sets the disabled attribute. */
	isDisabled: PropTypes.bool,
	/** When true, surfaces an error/validation message */
	hasError: PropTypes.bool,
	/** If hasError is true, this prop dicates the validation message shown. */
	validationMessage: PropTypes.string
};

ConfirmationCheckbox.defaultProps = {};

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var RadioIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "35" }));
});

var main$a = "Radio.js";
var deprecations$8 = [{
	replacements: {
		name: "GenericRadio",
		path: "Data/Capture/Radios"
	}
}];
var packageJson$a = {
	main: main$a,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$8
};

var Radio = function (_Component) {
	inherits(Radio, _Component);

	function Radio(props) {
		classCallCheck(this, Radio);

		var _this = possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(Radio, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    label = _props.label,
			    id = _props.id,
			    name = _props.name,
			    onChange = _props.onChange,
			    checked = _props.checked,
			    block = _props.block,
			    fullWidth = _props.fullWidth,
			    disabled = _props.disabled,
			    noIndicator = _props.noIndicator,
			    rest = objectWithoutProperties(_props, ['label', 'id', 'name', 'onChange', 'checked', 'block', 'fullWidth', 'disabled', 'noIndicator']);


			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$a, hasCustomMargins: true, layout: fullWidth ? 'block' : 'inline-block' },
				React.createElement(InputClickable, _extends({
					id: id,
					name: name,
					label: label,
					type: 'radio',
					onChange: onChange,
					checked: checked,
					disabled: disabled,
					className: classnames('c-a-radio', {
						'c-a-radio--full-width': fullWidth,
						'c-a-radio--block': block || noIndicator,
						'c-a-radio--no-indicator': noIndicator
					}),
					body: React.createElement(RadioIcon, { className: 'c-a-icon' }),
					ref: function ref(component) {
						_this2.refInput = component;
					}
				}, rest))
			);
		}
	}]);
	return Radio;
}(Component);

Radio.propTypes = {
	block: PropTypes.bool,
	checked: PropTypes.bool.isRequired,
	disabled: PropTypes.bool,
	fullWidth: PropTypes.bool,
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	noIndicator: PropTypes.bool
};

Radio.defaultProps = {
	block: false,
	fullWidth: false,
	disabled: false,
	noIndicator: false
};

var _templateObject$7 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledColumn = styled('div')(_templateObject$7, function (props) {
	return props.isXrayMode && '\n\t\tbackground: ' + colours.component.frame.deprecated.background + ';\n\t\tpadding: ' + spacing.DOUBLE + ' !important;\n\t';
});

var Column = function Column(_ref) {
	var _classnames;

	var push = _ref.push,
	    children = _ref.children,
	    xs = _ref.xs,
	    sm = _ref.sm,
	    md = _ref.md,
	    lg = _ref.lg,
	    xl = _ref.xl,
	    xsOffset = _ref.xsOffset,
	    smOffset = _ref.smOffset,
	    mdOffset = _ref.mdOffset,
	    lgOffset = _ref.lgOffset,
	    xlOffset = _ref.xlOffset,
	    className = _ref.className,
	    rest = objectWithoutProperties(_ref, ['push', 'children', 'xs', 'sm', 'md', 'lg', 'xl', 'xsOffset', 'smOffset', 'mdOffset', 'lgOffset', 'xlOffset', 'className']);

	var classname = classnames((_classnames = {
		'col--push': push
	}, defineProperty(_classnames, 'col-xs1-' + xs, xs), defineProperty(_classnames, 'col-sm1-' + sm, sm), defineProperty(_classnames, 'col-md1-' + md, md), defineProperty(_classnames, 'col-lg1-' + lg, lg), defineProperty(_classnames, 'col-xl1-' + xl, xl), defineProperty(_classnames, 'offset-xs1-' + xsOffset, xsOffset), defineProperty(_classnames, 'offset-sm1-' + smOffset, smOffset), defineProperty(_classnames, 'offset-md1-' + mdOffset, mdOffset), defineProperty(_classnames, 'offset-lg1-' + lgOffset, lgOffset), defineProperty(_classnames, 'offset-xl1-' + xlOffset, xlOffset), _classnames), className);
	var _window = window,
	    XrayHelper = _window.XrayHelper;

	var isXrayMode = XrayHelper && XrayHelper.checkIsXrayMode();

	return React.createElement(
		StyledColumn,
		_extends({}, rest, { className: classname, isXrayMode: isXrayMode }),
		children,
		isXrayMode && React.createElement(
			'span',
			null,
			React.createElement(
				'b',
				null,
				'Deprecated component: Column'
			)
		)
	);
};

var withinRange = function withinRange(min, max) {
	return function (props, propName, componentName) {
		var prop = props[propName];

		if (prop < min) {
			return new Error('Invalid value for ' + propName + ' supplied to ' + componentName + ' must be greater than ' + min + '.');
		}

		if (prop > max) {
			return new Error('Invalid value for ' + propName + ' supplied to ' + componentName + ' must be less than ' + max + '.');
		}

		return null;
	};
};

var RANGE_MIN_OFFSET = 0;
var RANGE_MIN = 1;
var RANGE_MAX = 24;

Column.propTypes = {
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	className: PropTypes.string,
	push: PropTypes.bool,
	lg: withinRange(RANGE_MIN, RANGE_MAX),
	lgOffset: withinRange(RANGE_MIN_OFFSET, RANGE_MAX),
	md: withinRange(RANGE_MIN, RANGE_MAX),
	mdOffset: withinRange(RANGE_MIN_OFFSET, RANGE_MAX),
	sm: withinRange(RANGE_MIN, RANGE_MAX),
	smOffset: withinRange(RANGE_MIN_OFFSET, RANGE_MAX),
	xl: withinRange(RANGE_MIN, RANGE_MAX),
	xlOffset: withinRange(RANGE_MIN_OFFSET, RANGE_MAX),
	xs: withinRange(RANGE_MIN, RANGE_MAX),
	xsOffset: withinRange(RANGE_MIN_OFFSET, RANGE_MAX)
};

var main$b = "Row.js";
var deprecations$9 = [{
	replacements: {
		name: "Inline",
		path: "Layout/Grids"
	}
}];
var packageJson$b = {
	main: main$b,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$9
};

var Row = function Row(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    rest = objectWithoutProperties(_ref, ['children', 'className']);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$b, hasCustomMargins: true },
		React.createElement(
			'div',
			_extends({}, rest, { className: classnames('row', className) }),
			children
		)
	);
};

Row.propTypes = {
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	className: PropTypes.string
};

var main$c = "DaySelector.js";
var deprecations$a = [{
	replacements: {
		name: "GenericRadio",
		path: "Data/Capture/Radios"
	}
}];
var packageJson$c = {
	main: main$c,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$a
};

var _templateObject$8 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t.c-a-radio {\n\t\tmin-width: 100%;\n\t}\n'], ['\n\tcolor: ', ';\n\t.c-a-radio {\n\t\tmin-width: 100%;\n\t}\n']);

var StyledWrapper$2 = styled('div')(_templateObject$8, function (props) {
	return props.theme.colours.bodyText;
});

var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

var DaySelector = function DaySelector(_ref) {
	var _onChange = _ref.onChange,
	    selected = _ref.selected;

	var nameId = uniqueId_1('day-selector-');
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$c, hasCustomMargins: true },
		React.createElement(
			StyledWrapper$2,
			null,
			React.createElement(
				Row,
				null,
				days.map(function (day) {
					return React.createElement(
						Column,
						{ key: day, sm: 8 },
						React.createElement(Radio, {
							block: true,
							checked: selected === days.indexOf(day) + 1,
							id: nameId + '-' + day.toLowerCase(),
							label: day,
							name: nameId,
							onChange: function onChange(e) {
								return _onChange(days.indexOf(e.target.value) + 1);
							},
							value: day
						})
					);
				})
			)
		)
	);
};

DaySelector.propTypes = {
	/** Callback function triggered on change.
  * Returns the index of the currently selected day when radio value changes. */
	onChange: PropTypes.func.isRequired,
	/** Selected index to set radio value on initial render. Adheres to ISO date week standard for numbering days. */
	selected: PropTypes.number.isRequired
};

DaySelector.defaultProps = {};

var main$d = "Input.js";
var packageJson$d = {
	main: main$d,
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
};

var Input = function (_Component) {
	inherits(Input, _Component);

	function Input() {
		classCallCheck(this, Input);

		var _this = possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this));

		_this.inputRef = null;
		return _this;
	}

	createClass(Input, [{
		key: 'focus',
		value: function focus() {
			if (this.inputRef) {
				this.inputRef.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasSuffix = _props.hasSuffix,
			    hasPrefix = _props.hasPrefix,
			    id = _props.id,
			    className = _props.className,
			    autoComplete = _props.autoComplete,
			    type = _props.type,
			    rest = objectWithoutProperties(_props, ['hasSuffix', 'hasPrefix', 'id', 'className', 'autoComplete', 'type']);


			var classNames = classnames('c-a-input', 'c-a-input--' + type, {
				'has-prefix': hasPrefix,
				'has-suffix': hasSuffix
			}, className);

			var inputProps = void 0;

			if (autoComplete) {
				inputProps = {
					autoComplete: autoComplete
				};
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$d, hasCustomMargins: true },
				React.createElement('input', _extends({}, rest, {
					className: classNames,
					id: id,
					ref: function ref(component) {
						_this2.inputRef = component;
					}
				}, inputProps, {
					type: type
				}))
			);
		}
	}]);
	return Input;
}(Component);

Input.propTypes = {
	/** Allows addition of classes. */
	className: PropTypes.string,
	/** Prefix on input. */
	hasPrefix: PropTypes.bool,
	/** Suffix on input. */
	hasSuffix: PropTypes.bool,
	/** Used to pair with associated form elements.
  * It relates the name attribute of the label to the id attribute of the input. */
	id: PropTypes.string,
	/** Specifies the type of input. */
	type: PropTypes.oneOf(['text', 'email', 'number', 'search', 'tel', 'url', 'password']),
	/** Allows us to decide whether an input has an automated assistance in filling out form field values. */
	autoComplete: PropTypes.string
};

var TextPrompt = function TextPrompt(_ref) {
	var children = _ref.children,
	    className = _ref.className;

	var classes = classnames('c-a-input-text-prompt', className);
	return React.createElement(
		'div',
		{ className: classes },
		children
	);
};

TextPrompt.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	className: PropTypes.string
};

var Prefix = function Prefix(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    isDisabled = _ref.isDisabled;
	return React.createElement(
		TextPrompt,
		{ className: classnames('c-a-input-text-prompt--prefix', { 'is-disabled': isDisabled }, className) },
		React.createElement(
			'div',
			{ className: 'c-a-input-text-prompt__title' },
			children
		)
	);
};

Prefix.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	className: PropTypes.string,
	isDisabled: PropTypes.bool
};

var Suffix = function Suffix(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    isDisabled = _ref.isDisabled;
	return React.createElement(
		TextPrompt,
		{ className: classnames('c-a-input-text-prompt--suffix', { 'is-disabled': isDisabled }, className) },
		React.createElement(
			'div',
			{ className: 'c-a-input-text-prompt__title' },
			children
		)
	);
};

Suffix.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	className: PropTypes.string,
	isDisabled: PropTypes.bool
};

var main$e = "FormField.js";
var packageJson$e = {
	main: main$e,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var FormField = function FormField(_ref) {
	var name = _ref.name,
	    description = _ref.description,
	    title = _ref.title,
	    titleText = _ref.titleText,
	    validationMessage = _ref.validationMessage,
	    hasError = _ref.hasError,
	    type = _ref.type,
	    prefix = _ref.prefix,
	    suffix = _ref.suffix,
	    onChange = _ref.onChange,
	    inputProps = _ref.inputProps,
	    supplement = _ref.supplement,
	    isRequired = _ref.isRequired;

	if (title !== undefined) {
		DeprecationWarnings.logProp(packageJson$e, 'title prop deprecated in favour of titleText prop.');
	}

	return React.createElement(
		Field,
		null,
		React.createElement(FieldHeader, {
			name: name,
			titleText: titleText || title,
			description: description,
			validationMessage: validationMessage,
			hasError: hasError,
			supplement: supplement
		}),
		React.createElement(
			FieldBody,
			{ hasError: hasError },
			React.createElement(
				'div',
				{ className: 'o-block-field__col-6 c-m-form-field__col' },
				prefix && React.createElement(
					Prefix,
					null,
					prefix
				),
				React.createElement(Input, _extends({
					id: name,
					name: name,
					type: type,
					onChange: onChange,
					hasPrefix: !!prefix,
					hasSuffix: !!suffix,
					'aria-invalid': hasError,
					'aria-required': isRequired,
					'aria-describedby': name + '-error'
				}, inputProps)),
				suffix && React.createElement(
					Suffix,
					null,
					suffix
				)
			)
		)
	);
};

FormField.propTypes = {
	/** A Name to uniquely identify component */
	name: PropTypes.string.isRequired,
	/** A short description for the user which explain about input field */
	description: PropTypes.string,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Add a title for the input field */
	titleText: PropTypes.string.isRequired,
	/** A message which is generally displayed in case of validation error */
	validationMessage: PropTypes.string,
	/** This value decides whether to show validation message along with styles */
	hasError: PropTypes.bool,
	/** Type of input to use, requires any valid html input type */
	type: PropTypes.string,
	/** Any prefix for the field */
	prefix: PropTypes.string,
	/** Any suffix for the field */
	suffix: PropTypes.string,
	/** Additional input props to pass to input field helpful for using 3rd party form libraries */
	inputProps: PropTypes.shape({}),
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Any additional text for user, placed besides title */
	supplement: PropTypes.string,
	/** An accessibility aria-required value. */
	isRequired: PropTypes.bool
};

FormField.defaultProps = {
	type: 'text',
	isRequired: false
};

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var EyehideOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.955 7.652c.068.091.068.206-.069.275l-1.121 1.12a9.392 9.392 0 0 1-3.73 2.358l-.046-.092-.8-1.396-.046-.091a2.91 2.91 0 0 0 .8-2.037c0-1.67-1.327-3.02-2.974-3.02-.229 0-.458.046-.687.091l-.045-.091-.55-.961a9.744 9.744 0 0 1 8.26 2.837l1.008 1.007zm-7.3 3.09l.046.09.595 1.007A9.62 9.62 0 0 1 1.15 9.048L.05 7.927a.209.209 0 0 1 0-.275l.984-1.007A9.902 9.902 0 0 1 4.88 4.242l.045.092.778 1.35.07.092a3.078 3.078 0 0 0-.756 2.013c0 1.67 1.327 3.02 2.975 3.02.228 0 .457-.022.663-.068zm-2.196-3.8l1.533 2.655c-.984 0-1.762-.8-1.762-1.785 0-.32.091-.618.229-.87zm3.317.847c0 .343-.091.64-.228.916l-1.556-2.7h.023c.96 0 1.761.8 1.761 1.784zm.07 2.38l.823 1.396.961 1.67-.755.435-1.099-1.9-.663-1.166-.64-1.076-1.717-2.997-.618-1.076-.8-1.373-.962-1.647L5.131 2 6.23 3.876l.64 1.122.618 1.075 1.74 3.02.617 1.076z" }));
});

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var EyeshowOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.952 7.918c.068.091.068.206-.046.274l-1.097 1.12a9.544 9.544 0 0 1-13.661 0L.051 8.192a.208.208 0 0 1 0-.274l1.006-1.005a9.736 9.736 0 0 1 13.89 0l1.005 1.005zm-7.928 3.175c1.622 0 2.97-1.347 2.97-3.015 0-1.668-1.325-3.016-2.97-3.016-1.644 0-2.97 1.348-2.97 3.016s1.326 3.015 2.97 3.015zm0-1.256a1.77 1.77 0 0 1-1.759-1.782 1.77 1.77 0 0 1 1.76-1.782c.97 0 1.758.798 1.758 1.782a1.77 1.77 0 0 1-1.759 1.782z" }));
});

var main$f = "PasswordReveal.js";
var packageJson$f = {
	main: main$f,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var PasswordReveal = function (_Component) {
	inherits(PasswordReveal, _Component);

	function PasswordReveal(props) {
		classCallCheck(this, PasswordReveal);

		var _this = possibleConstructorReturn(this, (PasswordReveal.__proto__ || Object.getPrototypeOf(PasswordReveal)).call(this, props));

		_this.state = {
			isPasswordVisible: false
		};

		_this.toggleIconVisibility = _this.toggleIconVisibility.bind(_this);
		return _this;
	}

	createClass(PasswordReveal, [{
		key: 'toggleIconVisibility',
		value: function toggleIconVisibility() {
			this.setState(function (prevState, _props) {
				return { isPasswordVisible: !prevState.isPasswordVisible };
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    legend = _props2.legend,
			    title = _props2.title,
			    titleText = _props2.titleText,
			    description = _props2.description,
			    hasError = _props2.hasError,
			    validationMessage = _props2.validationMessage,
			    id = _props2.id,
			    inputValue = _props2.inputValue,
			    requiredField = _props2.requiredField,
			    onChange = _props2.onChange,
			    onBlur = _props2.onBlur,
			    onFocus = _props2.onFocus;
			var isPasswordVisible = this.state.isPasswordVisible;


			var iconType = isPasswordVisible ? React.createElement(EyehideOutlineLarge, { className: 'c-a-icon' }) : React.createElement(EyeshowOutlineLarge, { className: 'c-a-icon' });

			if (title !== undefined) {
				DeprecationWarnings.logProp(packageJson$f, 'title prop deprecated in favour of titleText prop.');
			}

			return React.createElement(
				'fieldset',
				null,
				React.createElement(
					'legend',
					null,
					legend
				),
				React.createElement(
					'div',
					{ className: 'c-m-form-field' },
					React.createElement(FieldHeader, {
						name: id,
						titleText: titleText || title,
						description: description,
						hasError: hasError,
						validationMessage: validationMessage
					}),
					React.createElement(
						FieldBody,
						null,
						React.createElement('input', {
							type: isPasswordVisible ? 'text' : 'password',
							className: 'c-a-input c-a-input--password has-suffix',
							id: id,
							value: inputValue,
							required: requiredField,
							'aria-required': requiredField,
							onChange: onChange,
							onBlur: onBlur,
							onFocus: onFocus
						}),
						React.createElement(
							'button',
							{
								type: 'button',
								className: 'c-a-input-icon-control c-a-input-icon-control--suffix',
								onClick: this.toggleIconVisibility
							},
							iconType
						)
					)
				)
			);
		}
	}]);
	return PasswordReveal;
}(Component);

PasswordReveal.propTypes = {
	/** Represents a caption for the content of its parent fieldset. */
	legend: PropTypes.string,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** FieldHeader title message - typically Password. */
	titleText: PropTypes.string.isRequired,
	/** FieldHeader input description. */
	description: PropTypes.string,
	/** FieldHeader hasError - when true, surfaces an error message. */
	hasError: PropTypes.bool,
	/** FieldHeader if hasError is true, this prop dicates the validation message shown. */
	validationMessage: PropTypes.string,
	/** To ensure inputs are unique. */
	id: PropTypes.string.isRequired,
	/** Can prepopulate with an input if desired. */
	inputValue: PropTypes.string,
	/** Boolean for if input is required. This covers HTML5 required and aria-required attributes. */
	requiredField: PropTypes.bool,
	/** Callback function triggered on change. */
	onChange: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func
};

PasswordReveal.defaultProps = {
	hasError: false,
	onChange: function onChange() {},
	onBlur: function onBlur() {},
	onFocus: function onFocus() {}
};

/**
 * Generates the correct PropType when trying to ensure a specific Component
 * @param {Class} component the React component you expect the children to be
 * @returns {PropType}
 */
var componentPropType = function componentPropType(component) {
	var componentShape = PropTypes.shape({
		type: PropTypes.oneOf([component])
	});

	// Need to accept the class, false (conditional rendering) or a combination in array form
	return PropTypes.oneOfType([componentShape, PropTypes.oneOf([false]), PropTypes.arrayOf(PropTypes.oneOfType([componentShape, PropTypes.oneOf([false])]))]);
};

var main$g = "RadioCard.js";
var deprecations$b = [{
	replacements: {
		name: "GenericRadio",
		path: "Data/Capture/Radios"
	}
}];
var packageJson$g = {
	main: main$g,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$b
};

var RadioCardBody = function RadioCardBody(_ref) {
	var children = _ref.children;
	return React.createElement(
		'div',
		{ className: 'c-a-radio-card__body' },
		children
	);
};

RadioCardBody.propTypes = {
	children: PropTypes.node
};

var RadioCardContent = function RadioCardContent(_ref) {
	var heading = _ref.heading,
	    children = _ref.children;
	return React.createElement(
		'div',
		{ className: 'c-a-radio-card__content' },
		React.createElement(
			'div',
			{ className: 'c-a-radio-card__content-heading' },
			heading
		),
		children && React.createElement(
			'div',
			{ className: 'c-a-radio-card__content-summary u-rich-text' },
			children
		)
	);
};

RadioCardContent.propTypes = {
	heading: PropTypes.string,
	children: PropTypes.node
};

var RadioCardControl = function RadioCardControl(_ref) {
	var children = _ref.children;
	return React.createElement(
		'div',
		{ className: 'c-a-radio-card__control' },
		children
	);
};

RadioCardControl.propTypes = {
	children: PropTypes.node
};

var RadioCardFooter = function RadioCardFooter(_ref) {
	var children = _ref.children;
	return children ? React.createElement(
		'div',
		{ className: 'c-a-radio-card__footer' },
		children
	) : React.createElement('span', null);
};

RadioCardFooter.propTypes = {
	children: PropTypes.node
};

var RadioCardMedia = function RadioCardMedia(_ref) {
	var children = _ref.children;
	return children ? React.createElement(
		'div',
		{ className: 'c-a-radio-card__media' },
		children
	) : React.createElement('span', null);
};
RadioCardMedia.propTypes = {
	children: PropTypes.node
};

var RadioCard = function RadioCard(_ref) {
	var media = _ref.media,
	    id = _ref.id,
	    name = _ref.name,
	    checked = _ref.checked,
	    disabled = _ref.disabled,
	    required = _ref.required,
	    heading = _ref.heading,
	    summary = _ref.summary,
	    footer = _ref.footer,
	    onChange = _ref.onChange,
	    onClick = _ref.onClick,
	    onBlur = _ref.onBlur,
	    rest = objectWithoutProperties(_ref, ['media', 'id', 'name', 'checked', 'disabled', 'required', 'heading', 'summary', 'footer', 'onChange', 'onClick', 'onBlur']);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$g, hasCustomMargins: true },
		React.createElement(
			'div',
			{ className: 'c-a-radio-card' },
			React.createElement(
				RadioCardControl,
				null,
				React.createElement('input', {
					type: 'radio',
					onChange: onChange,
					onClick: onClick,
					onBlur: onBlur,
					id: id,
					name: name,
					checked: checked,
					disabled: disabled,
					required: required,
					'aria-describedby': rest['aria-describedby']
				}),
				React.createElement(
					'label',
					{ htmlFor: id },
					React.createElement(
						RadioCardBody,
						null,
						React.createElement(RadioIcon, { className: 'c-a-icon' }),
						React.createElement(
							RadioCardContent,
							{ heading: heading },
							summary && React.createElement(
								StandardBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									summary
								)
							)
						),
						React.createElement(
							RadioCardMedia,
							null,
							media
						)
					)
				)
			),
			React.createElement(
				RadioCardFooter,
				null,
				footer
			)
		)
	);
};

RadioCard.propTypes = {
	/** element placed on the right hand side of the radio card */
	media: PropTypes.node,
	/** id passed to input[type=radio] */
	id: PropTypes.string,
	/** name passed to input[type=radio] */
	name: PropTypes.string,
	/** determines whether or not the radioCard is in a checked state */
	checked: PropTypes.bool,
	/** determines whether or not the radioCard is in a disabled state */
	disabled: PropTypes.bool,
	/** determines whether or not the radioCard is in a required state */
	required: PropTypes.bool,
	/** heading displayed on the top of the radio card */
	heading: PropTypes.string,
	/** The main body of the radio card */
	summary: PropTypes.string,
	/** element placed on the bottom of the RadioCard: should only be an array of `Radio` components */
	footer: componentPropType(Radio),
	/** accessibility prop passed to input[type="radio"] */
	'aria-describedby': PropTypes.string,
	/**
  * input[type="radio"] onChange event
  *
  * @param {SyntheticEvent} event The react `SyntheticEvent`
  */
	onChange: PropTypes.func,
	/**
  * input[type="radio"] onClick event
  *
  * @param {SyntheticEvent} event The react `SyntheticEvent`
  */
	onClick: PropTypes.func,
	/** Callback function triggered on blur.
  *
  * @param {SyntheticEvent} event The react `SyntheticEvent`
  */
	onBlur: PropTypes.func
};

var main$h = "RadioCardGroup.js";
var deprecations$c = [{
	replacements: {
		name: "GenericRadio",
		path: "Data/Capture/Radios"
	}
}];
var packageJson$h = {
	main: main$h,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$c
};

var RadioCardGroup = function RadioCardGroup(_ref) {
	var legend = _ref.legend,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$h, hasCustomMargins: true },
		React.createElement(
			'div',
			{ className: 'c-m-radio-card-group' },
			React.createElement(
				'fieldset',
				null,
				React.createElement(
					'legend',
					null,
					legend
				),
				children
			)
		)
	);
};

RadioCardGroup.propTypes = {
	/** fieldset legend: not visible */
	legend: PropTypes.string.isRequired,
	/** one or more RadioCard components */
	children: PropTypes.arrayOf(componentPropType(RadioCard))
};

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var MagnifySolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon magnify"), React.createElement("path", { d: "M31.28 27.07l-7.653-7.653a12.46 12.46 0 0 0 1.82-6.5C25.446 5.994 19.448 0 12.526 0 5.608-.002 0 5.608 0 12.53c0 6.918 5.996 12.915 12.915 12.915 2.303 0 4.456-.626 6.31-1.71l7.693 7.7c.753.75 1.975.75 2.726 0l1.91-1.91c.75-.752.478-1.702-.273-2.454zM3.857 12.53c0-4.793 3.883-8.676 8.673-8.676s9.06 4.267 9.06 9.06a8.677 8.677 0 0 1-8.675 8.676c-4.792-.002-9.06-4.27-9.06-9.06z" }));
});

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({ width: "16", height: "16", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M29.9 29.901a4.103 4.103 0 0 0 0 5.803l12.294 12.294L29.9 60.3a4.102 4.102 0 0 0 5.803 5.8l12.294-12.296 12.3 12.296a4.103 4.103 0 1 0 5.803-5.803L53.8 47.993l12.296-12.298a4.1 4.1 0 0 0 .002-5.797 4.095 4.095 0 0 0-5.792-.001L48.007 42.196 35.704 29.9a4.104 4.104 0 0 0-5.803.001z" }), React.createElement("path", { d: "M48 0c26.508 0 48 21.492 48 48.003s-21.492 48-48 48c-26.511 0-48-21.489-48-48S21.489 0 48 0zm0 90.003c23.193 0 42-18.804 42-42 0-23.193-18.807-42-42-42-23.196 0-42 18.807-42 42 0 23.196 18.804 42 42 42z" }));
});

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React.createElement("svg", _extends$d({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M87.887 21.656c12.578 18.847 10.243 43.892-5.516 60.086l-.482.488a47.852 47.852 0 0 1-33.941 14.035C25.06 96.25 5.37 80.068.92 57.618S8.498 12.699 29.648 3.953c21.15-8.746 45.534-1.334 58.239 17.703zM47.947 8.308c-19.072.014-35.48 13.499-39.188 32.207-3.708 18.71 6.316 37.432 23.941 44.72 17.626 7.288 37.945 1.111 48.532-14.754 10.587-15.864 8.494-36.998-5-50.478A39.88 39.88 0 0 0 47.949 8.308zM62.09 28.49l5.656 5.656-14.143 14.142 14.143 14.143-5.656 5.656-14.143-14.143-14.142 14.143-5.656-5.656L42.29 48.288 28.149 34.146l5.656-5.656 14.142 14.142z" }));
});

var getCrossOutlineLarge = getThemeIcon(VMIcon$3, GenericIcon$3);

var _templateObject$9 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tmin-height: 48px;\n\tpadding: ', ' ', ';\n\ttext-decoration: underline;\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tmin-height: 48px;\n\tpadding: ', ' ', ';\n\ttext-decoration: underline;\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\t> div {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t}\n'], ['\n\t> div {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t}\n']);

var StyledCancelButton = styled('button')(_templateObject$9, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.colours.interaction;
}, spacing.HALF, spacing.DOUBLE);
var StyledInputWrapper = styled('div')(_templateObject2$6);

var Search = function (_Component) {
	inherits(Search, _Component);

	function Search(props) {
		classCallCheck(this, Search);

		var _this = possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

		_this.state = {
			isActive: false,
			searchTerm: ''
		};

		_this.blur = _this.blur.bind(_this);
		_this.change = _this.change.bind(_this);
		_this.reset = _this.reset.bind(_this);
		return _this;
	}

	createClass(Search, [{
		key: 'blur',
		value: function blur() {
			var searchTerm = this.state.searchTerm;

			this.setState(function () {
				return { isActive: !!searchTerm };
			});
		}
	}, {
		key: 'reset',
		value: function reset(e) {
			if (e) {
				e.preventDefault();
			}
			this.setState(function () {
				return { isActive: false, searchTerm: '' };
			});
			this.props.onChange('');
		}
	}, {
		key: 'change',
		value: function change(e) {
			var searchTerm = e.target.value;
			var isActive = !!searchTerm;
			this.setState({ isActive: isActive, searchTerm: searchTerm });
			this.props.onChange(searchTerm);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    _onSubmit = _props.onSubmit,
			    cancelButtonText = _props.cancelButtonText,
			    placeholder = _props.placeholder,
			    autoComplete = _props.autoComplete,
			    theme = _props.theme;
			var _state = this.state,
			    isActive = _state.isActive,
			    searchTerm = _state.searchTerm;


			var autoCompleteAsText = autoComplete ? 'on' : 'off';
			var CrossOutlineLargeIcon = getCrossOutlineLarge(theme.name);

			return React.createElement(
				'div',
				{ className: classnames('c-m-search', { 'c-m-search--is-active': isActive }) },
				React.createElement(
					'form',
					{
						className: 'c-m-search__form',
						onSubmit: function onSubmit(e) {
							e.preventDefault();
							_onSubmit(searchTerm);
						}
					},
					React.createElement(
						'div',
						{ className: 'c-m-search__container' },
						React.createElement(
							'div',
							{ className: 'c-m-search__field' },
							React.createElement(
								StyledInputWrapper,
								{ className: 'c-m-search__input' },
								React.createElement(
									Label,
									{ htmlFor: 'search-field' },
									'Search'
								),
								React.createElement(Input, {
									className: 'c-m-search__input-field',
									id: 'search-field',
									onBlur: this.blur,
									onChange: this.change,
									placeholder: placeholder,
									type: 'search',
									value: searchTerm,
									autoComplete: autoCompleteAsText
								})
							),
							React.createElement(
								'div',
								{ className: 'c-m-search__icon' },
								React.createElement(MagnifySolidLarge, { className: 'c-a-icon' })
							),
							React.createElement(
								'div',
								{ className: 'c-m-search__reset' },
								React.createElement('input', { tabIndex: '-1', onClick: this.reset, type: 'reset', value: 'reset' }),
								React.createElement(CrossOutlineLargeIcon, { className: 'c-a-icon' })
							)
						),
						React.createElement(
							'div',
							{ className: 'c-m-search__submit' },
							React.createElement(
								'button',
								{ type: 'submit' },
								'Submit'
							)
						),
						React.createElement(
							'div',
							{ className: 'c-m-search__button' },
							React.createElement(
								StyledCancelButton,
								{ id: 'search-cancel-button', onClick: function onClick(e) {
										return _this2.reset(e);
									} },
								cancelButtonText
							)
						)
					)
				)
			);
		}
	}]);
	return Search;
}(Component);

Search.propTypes = {
	/** Submit handler called when search form is submitted. */
	onSubmit: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func,
	/** Cancel button label. */
	cancelButtonText: PropTypes.string,
	/** Search input placeholder text. Treat this as a label for the input if no label associated. */
	placeholder: PropTypes.string,
	/** Allows us to decide whether an input has an automated assistance in filling out form field values. */
	autoComplete: PropTypes.bool
};

Search.defaultProps = {
	autoComplete: false,
	onSubmit: function onSubmit() {},
	onChange: function onChange() {},
	cancelButtonText: 'Cancel',
	placeholder: 'Search'
};

var WrappedSearch = withTheme(Search);

var _templateObject$a = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n'], ['\n\tdisplay: inline-flex;\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n\t', '\n\tcolor: ', ';\n\tpadding-left: 16px;\n\tborder-top-right-radius: 0px;\n\tborder-bottom-right-radius: 0px;\n\tmargin: 0px;\n'], ['\n\t', '\n\tcolor: ', ';\n\tpadding-left: 16px;\n\tborder-top-right-radius: 0px;\n\tborder-bottom-right-radius: 0px;\n\tmargin: 0px;\n']);

var StyledSearchForm = styled('div')(_templateObject$a);

var StyledSearch = styled(Input)(_templateObject2$7, externalMarginRegular, function (props) {
	return props.theme.colours.bodyText;
});

var SearchForm = function (_Component) {
	inherits(SearchForm, _Component);

	function SearchForm(props) {
		classCallCheck(this, SearchForm);

		var _this = possibleConstructorReturn(this, (SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).call(this, props));

		_this.state = {
			searchTerm: props.setValue || ''
		};

		_this.searchTextInputRef = null;

		_this.change = _this.change.bind(_this);
		return _this;
	}

	createClass(SearchForm, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (typeof nextProps.setValue === 'string') {
				this.setState(function () {
					return {
						searchTerm: nextProps.setValue
					};
				});
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (this.searchTextInputRef) {
				this.searchTextInputRef.focus();
			}
		}
	}, {
		key: 'change',
		value: function change(e) {
			var searchTerm = e.target.value;
			this.setState({ searchTerm: searchTerm });
			this.props.onChange(searchTerm);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    placeholder = _props.placeholder,
			    requiredField = _props.requiredField,
			    _onSubmit = _props.onSubmit;
			var searchTerm = this.state.searchTerm;


			return React.createElement(
				'form',
				{
					onSubmit: function onSubmit(e) {
						e.preventDefault();
						_onSubmit(searchTerm);
					}
				},
				React.createElement(
					FieldBody,
					null,
					React.createElement(
						StyledSearchForm,
						null,
						React.createElement(StyledSearch, {
							'aria-required': requiredField,
							onChange: this.change,
							placeholder: placeholder,
							required: requiredField,
							ref: function ref(component) {
								_this2.searchTextInputRef = component;
							},
							type: 'search',
							value: searchTerm
						}),
						React.createElement(
							'button',
							{ type: 'submit', className: 'c-a-input-icon-control c-a-input-icon-control--suffix' },
							React.createElement(MagnifySolidLarge, { className: 'c-a-icon' })
						)
					)
				)
			);
		}
	}]);
	return SearchForm;
}(Component);

SearchForm.propTypes = {
	/** Boolean for if field is required. This covers HTML5 required and aria-required attributes. */
	requiredField: PropTypes.bool,
	/** Submit handler called when search form is submitted. */
	onSubmit: PropTypes.func.isRequired,
	/** Callback function triggered on change. */
	onChange: PropTypes.func,
	/** Search input placeholder text. */
	placeholder: PropTypes.string,
	/** Set the value of the search field. */
	setValue: PropTypes.string
};

SearchForm.defaultProps = {
	onChange: function onChange() {},
	placeholder: 'Search',
	requiredField: false
};

var SegmentedControl = function SegmentedControl(_ref) {
	var children = _ref.children,
	    isInline = _ref.isInline,
	    className = _ref.className,
	    rest = objectWithoutProperties(_ref, ['children', 'isInline', 'className']);

	var classNames = classnames('c-m-segmented-control', {
		'c-m-segmented-control--inline': isInline
	}, className);
	return React.createElement(
		'div',
		_extends({}, rest, { className: classNames }),
		children
	);
};

SegmentedControl.propTypes = {
	isInline: PropTypes.bool,
	children: PropTypes.node.isRequired,
	className: PropTypes.string
};

SegmentedControl.defaultProps = {
	isInline: false
};

var SegmentedControlItem = function SegmentedControlItem(_ref) {
	var id = _ref.id,
	    name = _ref.name,
	    children = _ref.children,
	    checked = _ref.checked,
	    rest = objectWithoutProperties(_ref, ['id', 'name', 'children', 'checked']);
	return React.createElement(
		'div',
		_extends({}, rest, { className: 'c-a-radio c-a-radio--block c-a-radio--no-indicator' }),
		React.createElement('input', { type: 'radio', id: id, name: name, checked: checked, readOnly: true }),
		React.createElement(
			'label',
			{ htmlFor: id },
			React.createElement(
				'span',
				{ className: 'c-a-radio__body' },
				React.createElement(RadioIcon, { className: 'c-a-icon' }),
				React.createElement(
					'span',
					{ className: 'c-a-radio__title' },
					children
				)
			)
		)
	);
};

SegmentedControlItem.propTypes = {
	/** Boolean indicating whether control item is checked. */
	checked: PropTypes.bool.isRequired,
	/** Child content as node. */
	children: PropTypes.node.isRequired,
	/** HTML ID attribute for item as string. Must be unique to any given page. */
	id: PropTypes.string.isRequired,
	/** HTML name attribute for item as string. */
	name: PropTypes.string,
	/** Callback function triggered on click. */
	onClick: PropTypes.func
};

var regexes = {
	alphanumericOrSpace: /^[A-Z0-9\s]*$/,
	bfpo: /^BF\d ?\d[A-Z]{2}|BFPO ?\d{1,4}$/,
	legacyEmail: /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/,
	newEmail: /^[!#%$&'*+/=_a-z0-9-]+(\.[!#%$&'*+/=_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
	moneyFormatter: /\B(?=(\d{3})+(?!\d))/g,
	postcode: /^(([A-Z]{1,2}\d[A-Z\d]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?\d[A-Z]{2}|(KY\d|MSR|VG|AI)[ -]?\d{4}|[A-Z]{2} ?\d{2}|GE ?CX)$/,
	postcodeAlt: /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9]){1}([ ]?)([0-9][a-zA-z][a-zA-z]){1}$/,
	simplifiedAlpha: /([a-z])+/i,
	simplifiedNumeric: /([0-9])+/,
	specialCharacters: /([@!#%&'*+-/=?^_`{|}~])+/i
};

var moneyFormatter = regexes.moneyFormatter;


function lengthCalc(value, targetLength) {
	var newValue = value;
	var i = void 0;

	if (value.length < targetLength) {
		for (i = 0; i < targetLength - value.length; i += 1) {
			newValue = '0'.concat(newValue);
		}
	}
	return newValue;
}

var ACCOUNT_NUMBER_TARGET_LENGTH = 8;
var accountNumberFormat = function accountNumberFormat(value) {
	return '' + lengthCalc(value.toString(), ACCOUNT_NUMBER_TARGET_LENGTH);
};

var CARD_NUMBER_TARGET_LENGTH = 16;
var cardNumberFormat = function cardNumberFormat(value) {
	return '' + lengthCalc(value.toString(), CARD_NUMBER_TARGET_LENGTH).replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
};

var PENCE_DIVIDER = 100;
var penceCurrencyFormat = function penceCurrencyFormat(value, removePrefix) {
	return '' + (Math.sign(value) === -1 ? '-' : '') + (!removePrefix ? '£' : '') + (Math.abs(value) / PENCE_DIVIDER).toFixed(2).toString().replace(moneyFormatter, ',');
};

var poundCurrencyFormat = function poundCurrencyFormat(value) {
	return '\xA3' + value.toString().replace(moneyFormatter, ',');
};

var PRODUCT_NUMBER_TARGET_LENGTH = 3;
var productNumberFormat = function productNumberFormat(value) {
	return '' + lengthCalc(value.toString(), PRODUCT_NUMBER_TARGET_LENGTH);
};

var SORT_CODE_TARGET_LENGTH = 6;
var sortCodeFormat = function sortCodeFormat(value) {
	return '' + lengthCalc(value.toString(), SORT_CODE_TARGET_LENGTH).replace(/\B(?=(\d{2})+(?!\d))/g, '-');
};

var BankingUtils = {
	accountNumberFormat: accountNumberFormat,
	cardNumberFormat: cardNumberFormat,
	lengthCalc: lengthCalc,
	penceCurrencyFormat: penceCurrencyFormat,
	poundCurrencyFormat: poundCurrencyFormat,
	productNumberFormat: productNumberFormat,
	sortCodeFormat: sortCodeFormat
};

var _templateObject$b = taggedTemplateLiteral(['\n\twidth: 100%;\n\tdisplay: flex;\n\tmargin-bottom: -14px;\n'], ['\n\twidth: 100%;\n\tdisplay: flex;\n\tmargin-bottom: -14px;\n']),
    _templateObject2$8 = taggedTemplateLiteral(['\n\twidth: ', ';\n\tborder-left: 1px solid ', ';\n\theight: 10px;\n'], ['\n\twidth: ', ';\n\tborder-left: 1px solid ', ';\n\theight: 10px;\n']);

var StyledWrapper$3 = styled('div')(_templateObject$b);

var StyledMarker = styled('div')(_templateObject2$8, function (props) {
	return props.width + '%';
}, colours.component.border);

var IntervalMarkers = function IntervalMarkers(_ref) {
	var step = _ref.step,
	    max = _ref.max,
	    min = _ref.min;

	var WIDTH_MAX = 100;
	var range = max - min;
	var intervals = range / step;
	var intervalWidth = WIDTH_MAX / intervals;
	var markers = [].concat(toConsumableArray(Array(intervals).keys()));

	return React.createElement(
		StyledWrapper$3,
		null,
		markers.map(function (item) {
			return React.createElement(StyledMarker, { width: intervalWidth, key: 'marker-' + item });
		})
	);
};

IntervalMarkers.propTypes = {
	/** Value passed from slider  */
	step: PropTypes.number,
	/** Maximum value passed from slider */
	max: PropTypes.number.isRequired,
	/** Minimum value passed from slider */
	min: PropTypes.number.isRequired
};

IntervalMarkers.defaultProps = {};

var TooltipSlider = function TooltipSlider(_ref) {
	var title = _ref.title,
	    value = _ref.value,
	    max = _ref.max,
	    min = _ref.min,
	    step = _ref.step;

	var PERCENTAGE_DIVIDER = 100;
	var getRange = function getRange(max, min) {
		return max - min;
	};
	var perStepPercentage = function perStepPercentage(range, step) {
		return PERCENTAGE_DIVIDER / (range / step);
	};
	var currentStep = function currentStep(value, min, step) {
		return (value - min) / step;
	};

	var getTooltipSliderPositionMarginLeft = function getTooltipSliderPositionMarginLeft(stepOffset, tooltipPosition) {
		var BASE_BUTTON_SIZE = 32;
		var buttonSize = BASE_BUTTON_SIZE / 2;
		var tooltipOffset = -32;

		// Align to button center
		var y = buttonSize * stepOffset;
		var thumbOffset = buttonSize - y;

		tooltipPosition.marginLeft = tooltipOffset + thumbOffset;
	};

	var getTooltipPosition = function getTooltipPosition(value, max, min, step) {
		var tooltipPosition = {};

		var range = getRange(max, min);
		var stepPercentage = perStepPercentage(range, step);
		var stepNumber = currentStep(value, min, step);

		var leftPosition = stepPercentage * stepNumber + '%';

		tooltipPosition.left = leftPosition;

		// Align tooltip to center on step
		var stepPercentage2 = stepPercentage * 2;
		var x = stepPercentage2 * stepNumber;
		var stepOffset = x / PERCENTAGE_DIVIDER;

		getTooltipSliderPositionMarginLeft(stepOffset, tooltipPosition);

		return tooltipPosition;
	};

	var _getTooltipPosition = getTooltipPosition(value, max, min, step),
	    left = _getTooltipPosition.left,
	    marginLeft = _getTooltipPosition.marginLeft;

	return React.createElement(
		'div',
		{ className: 'c-m-segmented-slider__tooltip--wrapper' },
		React.createElement(
			'div',
			{ className: 'c-m-segmented-slider__tooltip', style: { left: left, marginLeft: marginLeft } },
			title
		)
	);
};

TooltipSlider.propTypes = {
	/** Text to appear in tooltip */
	title: PropTypes.string,
	/** Value passed from slider  */
	value: PropTypes.number.isRequired,
	/** Maximum value passed from slider  */
	max: PropTypes.number.isRequired,
	/** Minimum value passed from slider  */
	min: PropTypes.number.isRequired,
	/** step value passed from slider */
	step: PropTypes.number.isRequired
};

TooltipSlider.defaultProps = {};

var main$i = "SegmentedSlider.js";
var deprecations$d = [{
	replacements: {
		name: "SliderInput",
		path: "Data/Capture/Inputs"
	}
}];
var packageJson$i = {
	main: main$i,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$d
};

var _templateObject$c = taggedTemplateLiteral(['\n\twidth: ', '%;\n'], ['\n\twidth: ', '%;\n']);

var StyledTickMarks = styled('div')(_templateObject$c, function (props) {
	return props.width;
});

var TickMarks = function TickMarks(_ref) {
	var value = _ref.value,
	    min = _ref.min,
	    max = _ref.max,
	    step = _ref.step;

	var sliderLength = max - min;
	var isActive = (value - min) / step;
	if (isActive % 1 === 0) {
		isActive -= 1;
	}
	var stepCount = parseInt(sliderLength / step, 10);
	var WIDTH_MULTIPLIER = 100;
	return React.createElement(
		'div',
		{ className: 'c-m-segmented-slider__tickmarks', 'aria-hidden': 'true' },
		[].concat(toConsumableArray(Array(stepCount))).map(function (_, index) {
			var tickMarkClasses = classnames('c-m-segmented-slider__tickmarks-item', {
				'is-active': value && parseInt(isActive, 10) >= index
			});

			var width = WIDTH_MULTIPLIER * (step / sliderLength);

			return React.createElement(StyledTickMarks, { className: tickMarkClasses, width: width, key: String(index) });
		})
	);
};

TickMarks.propTypes = {
	value: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	step: PropTypes.number.isRequired
};

var _templateObject$d = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: ', ';\n\tmin-height: 32px;\n\tmin-width: 32px;\n\tpadding: 0;\n\ttransition: background-color 0.3s ease-in-out;\n\n\t:after {\n\t\tborder-radius: 100%;\n\t}\n\n\tsvg {\n\t\tfill: ', ' !important;\n\t\ttransition: fill 0.3s ease-in-out, transform 0.1s ease-in-out;\n\t}\n\n\t', ';\n\n\t&:focus {\n\t}\n'], ['\n\talign-items: center;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: ', ';\n\tmin-height: 32px;\n\tmin-width: 32px;\n\tpadding: 0;\n\ttransition: background-color 0.3s ease-in-out;\n\n\t:after {\n\t\tborder-radius: 100%;\n\t}\n\n\tsvg {\n\t\tfill: ', ' !important;\n\t\ttransition: fill 0.3s ease-in-out, transform 0.1s ease-in-out;\n\t}\n\n\t', ';\n\n\t&:focus {\n\t}\n']);

var StyledButton$2 = styled('button')(_templateObject$d, colours.component.background, function (props) {
	return props.theme.colours.interaction;
}, spacing.HALF, function (props) {
	return props.disabled ? 'hsl(0deg 0% 46%)' : function (props) {
		return props.theme.colours.interaction;
	};
}, function (props) {
	return !props.disabled && '\n\t\t&:hover {\n\t\t\tbackground-color: ' + props.theme.colours.interaction + ';\n\n\t\t\tsvg {\n\t\t\t\tfill: ' + colours.generalPalette.white + ' !important;\n\t\t\t}\n\t\t}\n\t';
});

var getToolTip = function getToolTip(tooltipTitle, value, min, max, step) {
	return tooltipTitle !== undefined && React.createElement(TooltipSlider, { title: tooltipTitle, value: value, min: min, max: max, step: step });
};

var SegmentedSlider = function SegmentedSlider(_ref) {
	var onChange = _ref.onChange,
	    slideFinish = _ref.slideFinish,
	    value = _ref.value,
	    max = _ref.max,
	    min = _ref.min,
	    disabled = _ref.disabled,
	    leftIcon = _ref.leftIcon,
	    rightIcon = _ref.rightIcon,
	    step = _ref.step,
	    label = _ref.label,
	    className = _ref.className,
	    hasControls = _ref.hasControls,
	    hasTickmarks = _ref.hasTickmarks,
	    hasMinMaxLabels = _ref.hasMinMaxLabels,
	    tooltipTitle = _ref.tooltipTitle,
	    majorInterval = _ref.majorInterval;

	if (min % step !== 0 || max % step !== 0) {
		DeprecationWarnings.warn(__dirname + 'SegmentedSlider: In order for the segmentation to work properly, the min and max values' + 'specified must be divisible by the step value' + ' given with no remainder. For example, min: 0, max: 50, step: 10. (0/10 = 0, 50/10 = 5)');
	}

	var segmentedSliderClasses = classnames('c-m-segmented-slider', {
		'c-m-segmented-slider--disabled': disabled,
		'c-m-segmented-slider--no-controls': !hasControls,
		'c-m-segmented-slider--no-tickmarks': !hasTickmarks,
		'c-m-segmented-slider--no-labels': !hasMinMaxLabels,
		'c-m-segmented-slider--tooltip': tooltipTitle
	});
	var minLabel = BankingUtils.poundCurrencyFormat(min);
	var maxLabel = BankingUtils.poundCurrencyFormat(max);

	var stepUp = function stepUp(value, step) {
		return value + step <= max ? value + step : max;
	};
	var stepDown = function stepDown(value, step) {
		return value - step >= min ? value - step : min;
	};

	var disableMinusButton = value === min || disabled;
	var disableAddButton = value === max || disabled;

	var passSliderValueFromEvent = function passSliderValueFromEvent(callbackFunc) {
		return function (event) {
			var getIntValueFromEvent = function getIntValueFromEvent(_ref2) {
				var value = _ref2.currentTarget.value;
				return parseInt(value, 10);
			};
			var intValue = getIntValueFromEvent(event);
			callbackFunc(intValue);
		};
	};

	var showTickMarks = !majorInterval && hasTickmarks;

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$i },
		React.createElement(
			'fieldset',
			{ className: className },
			React.createElement(
				'legend',
				null,
				label
			),
			React.createElement(
				'div',
				{ className: segmentedSliderClasses },
				React.createElement(
					'div',
					{ className: 'c-m-segmented-slider__control c-m-segmented-slider__control--left' },
					React.createElement(
						StyledButton$2,
						{
							disabled: disableMinusButton,
							className: 'c-a-button c-a-button--rounded',
							width: 'flush',
							size: 'xs',
							display: 'secondary',
							type: 'button',
							onClick: function onClick() {
								onChange(stepDown(value, step));
								slideFinish(stepDown(value, step));
							}
						},
						leftIcon
					)
				),
				React.createElement(
					'div',
					{ className: 'c-m-segmented-slider__body' },
					getToolTip(tooltipTitle, value, min, max, step),
					showTickMarks && React.createElement(TickMarks, { min: min, max: max, step: step, value: value }),
					majorInterval && React.createElement(IntervalMarkers, { step: majorInterval, max: max, min: min }),
					React.createElement(
						'div',
						{ className: 'c-m-segmented-slider__range' },
						React.createElement(
							'label',
							{ className: 'u-visually-hidden' },
							label
						),
						React.createElement('input', {
							type: 'range',
							className: 'c-a-input-range',
							onChange: passSliderValueFromEvent(onChange),
							onMouseUp: passSliderValueFromEvent(slideFinish),
							onTouchEnd: passSliderValueFromEvent(slideFinish),
							onKeyUp: passSliderValueFromEvent(onChange),
							value: value,
							max: max,
							min: min,
							disabled: disabled,
							step: step
						})
					),
					React.createElement(
						'div',
						{ className: 'c-m-segmented__label', 'aria-hidden': 'true' },
						React.createElement(
							'div',
							{ className: 'c-m-segmented__label-min' },
							minLabel
						),
						React.createElement(
							'div',
							{ className: 'c-m-segmented__label-max' },
							maxLabel
						)
					)
				),
				React.createElement(
					'div',
					{ className: 'c-m-segmented-slider__control c-m-segmented-slider__control--right' },
					React.createElement(
						StyledButton$2,
						{
							disabled: disableAddButton,
							className: 'c-a-button c-a-button--rounded',
							width: 'flush',
							size: 'xs',
							display: 'secondary',
							type: 'button',
							onClick: function onClick() {
								onChange(stepUp(value, step));
								slideFinish(stepUp(value, step));
							}
						},
						rightIcon
					)
				)
			)
		)
	);
};

SegmentedSlider.propTypes = {
	disabled: PropTypes.bool,
	max: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
	/** Function maps to range inputs 'onMouseUp' event */
	slideFinish: PropTypes.func,
	value: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	leftIcon: PropTypes.node.isRequired,
	rightIcon: PropTypes.node.isRequired,
	step: PropTypes.number.isRequired,
	className: PropTypes.string,
	hasControls: PropTypes.bool,
	hasTickmarks: PropTypes.bool,
	hasMinMaxLabels: PropTypes.bool,
	tooltipTitle: PropTypes.string,
	/** visual marker displayed at this increment */
	majorInterval: PropTypes.number
};

SegmentedSlider.defaultProps = {
	disabled: false,
	slideFinish: function slideFinish() {}
};

export { WrappedAutocomplete as Autocomplete, ConfirmationCheckbox, DaySelector, Field, FieldBody, FieldHeader, FormField, PasswordReveal, RadioCardGroup, WrappedSearch as Search, SearchForm, SegmentedControl, SegmentedControlItem, SegmentedSlider, ValidationMessageWithTheme as ValidationMessage };
